/* Gogo Textos de Lenguaje

Tabla de Contenido

01.General
02.Inicio de sesión de usuario, cierre de sesión, registro
03.Menú
04.Tableros
05.Esquemas
06.Aplicaciones
  06.01.Chatea
  06.02.Encuesta
  06.03.Notas
07.IU
  07.01.Alertas
  07.02.Badges
  07.03.Botones
  07.04.Tarjetas
  07.05.Carrusel
  07.06.Gráficos
  07.07.Colapso
  07.08.Desplegables
  07.09.Editores
  07.10.Formularios
  07.11.Componentes
  07.12.Iconos
  07.13.Grupos de Entrada
  07.14.Jumbotron
  07.15.Modal
  07.16.Navegación
  07.17.Tooltips y Popovers
  07.18.Ordenable
  07.19.Maps
  07.20.Tables
*/

module.exports = {
  "menu.overview": "Visión General",
  "menu.sales": "Ventas",
  "menu.inventory-management": "Inventario y Stock",
  "menu.crm": "Clientes y Socios",
  "menu.finance": "Finanzas e Impuestos",
  "menu.utilities": "Utilidades",
  "menu.role": "Crear Permiso",
  "menu.user-role": "Crear Cuenta",
  "menu.form-dynamic": "Formulario Dinámico",
  "menu.companies": "Empresas Afiliadas",
  "product.tax-rate": "Tasa de impuesto",
  "table.import.tax-rate": "Tasa de impuesto (%)",
  /* 01.General */
  "general.copyright": "Gogo React © Todos los derechos reservados.",
  "general.btn-order-preview": "Ver producto",
  "general.product-unit": "productos",
  "general.loading": "Cargando...",
  "general.done": "Hecho",
  "print.shipping": "Envío",
  "general.not-yet": "Aún no",
  "general.error.title": "¡Error!",
  "general.btn-cancel": "Cancelar",
  "role.default.cashier": "Cajero",
  "role.default.kitchen": "Bar / Cocina",
  "role.default.table-pending-payment": "Mesero",
  "order.adjustment.add-products-first":
    "Añada productos antes de introducir un código",
  "order.adjustment.invalid-code": "Código promocional no válido",
  "order.adjustment.apply": "Aplicar",
  "order.adjustment.note-optional": "Nota (opcional)",
  "order.adjustment.promo-code": "Código promocional",
  "order.adjustment.promo-placeholder": "Introduzca el código promocional",
  "order.adjustment.coupon-help":
    "Introduzca un código y pulse Aplicar para recibir el descuento.",
  "order.adjustment.remove-code": "Quitar código promocional",
  "order.adjustment.discount-value": "Valor del descuento",
  "order.adjustment.estimated-discount": "Descuento estimado",
  "order.adjustment.discount-note-placeholder": "Ejemplo: Cliente fiel",
  "order.adjustment.subtotal": "Subtotal",
  "order.adjustment.total-after-discount": "Total después del descuento",
  "order.adjustment.tax-title": "Añadir impuesto",
  "order.adjustment.tax-rate": "Tasa de impuesto",
  "order.adjustment.other": "Otro",
  "order.adjustment.tax-value": "Valor del impuesto",
  "order.adjustment.estimated-tax": "Impuesto estimado",
  "order.adjustment.calculation": "Cálculo",
  "order.adjustment.tax-added": "Añadir al pedido",
  "order.adjustment.tax-added-help":
    "El impuesto se añadirá al total del pago.",
  "order.adjustment.tax-included": "Incluido en el precio",
  "order.adjustment.tax-included-help":
    "El impuesto ya está incluido en el precio del producto o servicio.",
  "order.adjustment.tax-note-placeholder": "Ejemplo: IVA de venta minorista",
  "order.adjustment.total-payment": "Total a pagar",
  "order.adjustment.fee-title": "Añadir recargo",
  "order.adjustment.fee-name": "Nombre del recargo",
  "order.adjustment.shipping-fee": "Gastos de envío",
  "order.adjustment.service-fee": "Tarifa de servicio",
  "order.adjustment.packing-fee": "Tarifa de embalaje",
  "order.adjustment.other-fee": "Otro recargo",
  "order.adjustment.fee-value": "Valor del recargo",
  "order.adjustment.estimated-fee": "Recargo estimado",
  "order.adjustment.apply-on": "Aplicar a",
  "order.adjustment.calculation-base": "Base de cálculo del recargo",
  "order.adjustment.fixed-fee-base-help":
    "Un recargo fijo en VND no depende de una base de cálculo.",
  "order.adjustment.after-discount": "Total después del descuento",
  "order.adjustment.fee-note-placeholder": "Ejemplo: Entrega local",

  /* 02.Inicio de sesión de usuario, cierre de sesión, registro */
  "user.login-title": "Iniciar sesión",
  "user.register": "Registro",
  "user.forgot-password": "Se te olvidó tu contraseña",
  "user.email": "Email",
  "user.password": "Contraseña",
  "user.forgot-password-question": "¿Contraseña olvidada?",
  "user.fullname": "Nombre completo",
  "user.login-button": "INICIAR SESIÓN",
  "user.register-button": "REGISTRO",
  "user.reset-password-button": "REINICIAR",
  "user.buy": "COMPRAR",
  "user.username": "Nombre de Usuario",

  /* 03.Menú */
  "menu.app": "Inicio",
  "menu.dashboards": "Tableros",
  "menu.default": "Defecto",
  "menu.analytics": "Analítica",
  "menu.ecommerce": "Comercio electrónico",
  "menu.content": "Contenido",
  "menu.pages": "Páginas",
  "menu.data-list": "Lista Datos",
  "menu.thumb-list": "Pulgares",
  "menu.image-list": "Lista Imagen",
  "menu.details": "Detalles",
  "menu.search": "Búsqueda",
  "menu.login": "Iniciar sesión",
  "menu.register": "Registro",
  "menu.forgot-password": "Olvidé mi contraseña",
  "menu.error": "Error",
  "menu.applications": "Aplicaciones",
  "menu.facebook-ads": "Facebook Ads",
  "menu.fb-ads-dashboard": "Dashboard",
  "menu.fb-ads-campaigns": "Campaigns",
  "menu.fb-ads-reports": "Reports",
  "menu.fb-ads-settings": "Settings",
  "menu.todo": "Notas",
  "menu.survey": "Encuesta",
  "menu.chat": "Chatea",
  "menu.ui": "IU",
  "menu.alerts": "Alertas",
  "menu.badges": "Badges",
  "menu.buttons": "Botones",
  "menu.cards": "Tarjetas",
  "menu.carousel": "Carrusel",
  "menu.charts": "Gráficos",
  "menu.collapse": "Colapso",
  "menu.dropdowns": "Menús Desplegables",
  "menu.editors": "Editores",
  "menu.form-layouts": "Diseños de Formulario",
  "menu.form-components": "Componentes de Formulario",
  "menu.form-validations": "Validaciones de Formulario",
  "menu.icons": "Iconos",
  "menu.input-groups": "Grupos de Entrada",
  "menu.jumbotron": "Jumbotron",
  "menu.modal": "Modal",
  "menu.navigation": "Navegación",
  "menu.popover-tooltip": "Tooltips y Popovers",
  "menu.sortable": "Ordenable",
  "menu.tables": "Tablas",
  "menu.menu": "Menú",
  "menu.subhidden": "Sub Oculto",
  "menu.hidden": "Oculto",
  "menu.visible": "Visible",
  "menu.maps": "Mapas",

  "menu.landingpage": "Página de Destino",
  "menu.multipage-home": "Múltiple Página",
  "menu.singlepage-home": "Una Página",
  "menu.about": "Acerca de",
  "menu.auth-login": "Autenticación",
  "menu.auth-register": "Registro",
  "menu.blog": "Blog",
  "menu.blog-detail": "Detalle del Blog",
  "menu.careers": "Carrera",
  "menu.confirmation": "Confirmación",
  "menu.contact": "Contacto",
  "menu.docs": "Docs",
  "menu.features": "Caracteristicas",
  "menu.prices": "Precios",
  "menu.videos": "Videos",
  "menu.mailing": "Correo",
  "menu.invoice": "Factura",
  "menu.sales-invoice": "Facturas de venta",
  "menu.einvoice": "Facturas electrónicas",
  "menu.blank-page": "Blank Page",
  "menu.types": "Menu Types",
  "menu.levels": "Menu Levels",
  "menu.third-level-1": "Third Level 1",
  "menu.third-level-2": "Third Level 2",
  "menu.third-level-3": "Third Level 3",

  /* 04.Tableros */
  "dashboards.pending-orders": "Pedidos Pendientes",
  "dashboards.completed-orders": "Pedidos Completados",
  "dashboards.refund-requests": "Petición de Reembolso",
  "dashboards.new-comments": "Nuevos Comentarios",
  "dashboards.sales": "Ventas",
  "dashboards.orders": "Pedidos",
  "dashboards.refunds": "Reembolso",
  "dashboards.recent-orders": "Pedidos Recientas",
  "dashboards.product-categories": "Categorías de Producto",
  "dashboards.cakes": "Tortas",
  "dashboards.tickets": "Entradas",
  "dashboards.calendar": "Calendario",
  "dashboards.best-sellers": "Mejores Vendidos",
  "dashboards.website-visits": "Visitas al sitio web",
  "dashboards.unique-visitors": "Visitantes únicos",
  "dashboards.this-week": "Esta Semana",
  "dashboards.last-week": "La Semana Pasada",
  "dashboards.this-month": "Este Mes",
  "dashboards.conversion-rates": "Medidas de Conversión",
  "dashboards.per-session": "Por Sección",
  "dashboards.profile-status": "Estado del Perfil",
  "dashboards.payment-status": "Estado del Pago",
  "dashboards.work-progress": "Trabajo en Progreso",
  "dashboards.tasks-completed": "Tareas Completadas",
  "dashboards.payments-done": "Pagos Realizados",
  "dashboards.order-stock": "Pedidos - Valores",
  "dashboards.categories": "Categorías",
  "dashboards.quick-post": "Publicación Rápida",
  "dashboards.title": "Título",
  "dashboards.content": "Contenido",
  "dashboards.category": "Categoría",
  "dashboards.save-and-publish": "Guardar y Publicar",
  "dashboards.top-viewed-posts": "Publicaciones Más Vistas",
  "dashboards.posts": "Puestos",
  "dashboards.pending-for-publish": "Pendiente de Publicación",
  "dashboards.users": "Usuarios",
  "dashboards.on-approval-process": "En Proceso de Aprobación",
  "dashboards.alerts": "Alertas",
  "dashboards.waiting-for-notice": "Esperando Aviso",
  "dashboards.files": "Archivos",
  "dashboards.pending-for-print": "Pendiente para imprimir",
  "dashboards.logs": "Troncos",
  "dashboards.gogo": "GOGO",
  "dashboards.magic-is-in-the-details": "LA MAGIA ESTA EN LOS DETALLES",
  "dashboards.yes-it-is-indeed": "¡Si es verdad!",
  "dashboards.advanced-search": "Búsqueda Avanzada",
  "dashboards.toppings": "Coberturas",
  "dashboards.type": "Categoría",
  "dashboards.keyword": "Palabra Clave",
  "dashboards.search": "Búsqueda",
  "dashboards.top-rated-items": "Artículos Mejores Valorados",

  /* Backend API validation messages */
  "product.api.error.price-invalid": "El precio del producto no es válido (debe ser >= 0)",
  "product.api.error.promo-price-invalid": "El precio promocional no es válido (debe ser >= 0)",
  "product.api.error.barcode-invalid": "El código de barras no es válido (se requieren 8-13 dígitos)",
  "product.api.error.sku-duplicate": "Este SKU ya existe en el sistema",
  "product.api.error.category-not-found": "La categoría del producto no existe",
  "product.api.error.duplicate": "Este producto ya existe en el sistema",
  "product.api.error.limit-reached": "Se alcanzó el límite de productos. ¡Actualice su plan para crear más!",
  "product.api.error.not-found": "Producto no encontrado o acceso denegado",
  "product.api.error.variant-price-invalid": "El precio de la variante no es válido (debe ser >= 0)",
  "product.api.error.variant-promo-invalid": "El precio promocional de la variante no es válido (debe ser >= 0)",
  "product.api.error.import-missing-fields": "Al producto le falta el nombre o la categoría",

  /* Product OCR */
  "product.ocr.title": "Extraer productos de imagen",
  "product.ocr.description": "Sube fotos de menú/lista de precios, la IA detectará los productos automáticamente.",
  "product.ocr.prompt-placeholder": "Dejar vacío = detección automática según tipo de negocio",
  "product.ocr.choose-images": "Elegir imágenes",
  "product.ocr.more-images": "imágenes más",
  "product.ocr.show-prompt": "Personalizar prompt de IA",
  "product.ocr.hide-prompt": "Ocultar prompt personalizado",
  "product.ocr.extract-btn": "Extraer datos",
  "product.ocr.extracting": "Procesando...",
  "product.ocr.save-btn": "Guardar",
  "product.ocr.saving": "Guardando...",
  "product.ocr.save-success": "¡Importación de productos exitosa!",
  "product.ocr.items": "productos",
  "product.ocr.col-name": "Nombre del producto",
  "product.ocr.col-category": "Categoría",
  "product.ocr.col-size": "Tamaño",
  "product.ocr.col-price": "Precio",
  "product.ocr.col-price-sale": "Precio de oferta",
  "product.ocr.col-barcode": "Código de barras",
  "product.ocr.step-upload": "Subir",
  "product.ocr.step-mapping": "Mapear columnas",
  "product.ocr.step-preview": "Revisar y Guardar",
  "product.ocr.mapping-title": "Mapear columnas de datos",
  "product.ocr.mapping-desc": "La IA detectó las columnas a la izquierda. Asígnalas a los campos de producto correspondientes a la derecha.",
  "product.ocr.ai-column": "Columna IA",
  "product.ocr.db-field": "Campo de datos",
  "product.ocr.status": "Estado",
  "product.ocr.skip-column": "-- Omitir --",
  "product.ocr.mapped": "Asignado",
  "product.ocr.rows-found": "filas de datos",
  "product.ocr.cols-mapped": "columnas asignadas",
  "product.ocr.back": "Volver",
  "product.ocr.next": "Continuar",
  "product.ocr.reset": "Reiniciar",
  "product.ocr.preview-title": "Revisar & Guardar",
  "product.ocr.stat-products": "Productos",
  "product.ocr.stat-categories": "Categorías",
  "product.ocr.stat-with-price": "Con precio",
  "product.ocr.import-done": "¡Listo!",
  "product.ocr.created": "Creados",
  "product.ocr.updated": "Actualizados",
  "product.ocr.skipped": "Omitidos",
  "product.ocr.raw-result": "Resultado bruto de IA:",
  "product.ocr.error-no-image": "Selecciona al menos una imagen.",
  "product.ocr.error-no-data": "No se pudieron extraer datos de la imagen. Intenta de nuevo.",
  "product.ocr.error-extract": "Ocurrió un error al analizar la imagen.",
  "product.ocr.error-empty": "No hay datos para guardar.",
  "product.ocr.error-save": "Ocurrió un error, intenta de nuevo.",
  "product.ocr.error-name-required": "Debes asignar la columna 'Nombre del producto' para continuar.",

  /* 05.Esquemas */
  "pages.add-new": "AGREGAR NUEVO",
  "pages.add-new-modal-title": "Agregar ítem nuevo",
  "pages.display-options": "Opciones de Pantalla",
  "pages.orderby": "Ordenar por : ",
  "pages.product-name": "Nombre del Producto",
  "pages.category": "Categoría",
  "pages.description": "Descripción",
  "pages.status": "Estado",
  "pages.cancel": "Cancelar",
  "pages.submit": "Enviar",
  "pages.delete": "Borrar",
  "pages.another-action": "Otra accion",
  "pages.actions": "ACCIONES",
  "pages.header": "Encabezado",
  "pages.details": "DETALLES",
  "pages.orders": "PEDIDOS",
  "pages.rating": "Clasificación",
  "pages.price": "Precio",
  "pages.ingredients": "Ingredients",
  "pages.is-vegan": "Es Vegano",
  "pages.order-status": "Estado del Pedido",
  "pages.bake-progress": "Progreso de Hornear",
  "pages.popularity": "Popularidad",
  "pages.comments": "Comentarios",
  "pages.error-title": "Vaya, parece que ha ocurrido un error!",
  "pages.error-code": "Código de error",
  "pages.go-back-home": "REGRESAR A INICIO",
  "pages.mailing-info":
    "Las plantillas de correo utilizan el diseño en línea y el diseño de la tabla para mostrarse bien en varios proveedores de servicios. Para proporcionar una mejor usabilidad, lo incluimos como html regular con dangerouslySetInnerHTML.",
  "pages.invoice-info":
    "La plantilla de factura tiene una versión de estilo en línea para uso fuera del proyecto, así como la versión React.",
  "pages.react-version": "React Versión",
  "pages.inline-version": "Estilo en Linea Html Versión",

  /* 06.Aplicaciones */

  /* 06.01.Chatea */
  "chat.messages": "Mensajes",
  "chat.contacts": "Contactos",
  "chat.saysomething": "Di algo..",
  /* 06.02.Encuesta */
  "survey.delete": "Borrar",
  "survey.edit": "Edit",
  "survey.add-new": "AGREGAR NUEVO",
  "survey.add-new-title": "Add New Encuesta",
  "survey.title": "Título",
  "survey.category": "Categoría",
  "survey.label": "Etiqueta",
  "survey.status": "Estado",
  "survey.cancel": "Cancelar",
  "survey.submit": "Enviar",
  "survey.another-action": "Otra accion",
  "survey.display-options": "Opciones de Pantalla",
  "survey.orderby": "Ordenar por : ",
  "survey.all-surveys": "Todas las Encuestas",
  "survey.completed-surveys": "Encuestas Completadas",
  "survey.categories": "Categorías",
  "survey.active-surveys": "Encuestas Activas",
  "survey.labels": "Etiquetas",

  /* 06.03.Notas */
  "todo.add-new": "AGREGAR NUEVO",
  "todo.add-new-modal-title": "Añadir Nuevo",
  "todo.title": "Título",
  "todo.detail": "Detalle",
  "todo.category": "Categoría",
  "todo.label": "Etiqueta",
  "todo.status": "Estado",
  "todo.cancel": "Cancelar",
  "todo.submit": "Enviar",
  "todo.action": "Accion",
  "todo.another-action": "Otra accion",
  "todo.display-options": "Opciones de Pantalla",
  "todo.orderby": "Ordenar por : ",
  "todo.all-tasks": "Todas las Tareas",
  "todo.pending-tasks": "Tareas Pendientes",
  "todo.completed-tasks": "Tareas Completadas",
  "todo.categories": "Categorías",
  "todo.labels": "Etiquetas",

  /* 07.IU */

  /* 07.01.Alertas */
  "alert.rounded": "Alerta Redondeado",
  "alert.react-notifications": "React Notificaciones",
  "alert.outline": "Contorno",
  "alert.primary": "Primary",
  "alert.secondary": "Secondary",
  "alert.info": "Info",
  "alert.success": "Success",
  "alert.warning": "Warning",
  "alert.error": "Error",
  "alert.filled": "Lleno",
  "alert.primary-text": "¡Esto es un primary alert—check fuera!",
  "alert.secondary-text": "¡Esto es un secondary alert—check fuera!",
  "alert.success-text": "¡Esto es un success alert—check fuera!",
  "alert.danger-text": "¡Esto es un danger alert—check fuera!",
  "alert.warning-text": "¡Esto es un warning alert—check fuera!",
  "alert.info-text": "¡Esto es un info alert—check fuera!",
  "alert.light-text": "¡Esto es un light alert—check fuera!",
  "alert.dark-text": "¡Esto es un dark alert—check fuera!",
  "alert.default": "Alerta por Defecto",
  "alert.dismissing": "Despido de Alerta",
  "alert.dismissing-text":
    "¡Santo guacamole! Debes revisar algunos de esos campos a continuación.",
  "alert.dismissing-without-animate-text":
    "¡Estoy alerta y me pueden despedir sin animarme!",

  /* 07.02.Badges */
  "badge.sizes": "Tamaños",
  "badge.colors": "Colores",
  "badge.outline": "Contorno",
  "badge.links": "Enlaces",
  "badge.counter-badges": "Mostrador Badges",
  "badge.bootstrap-default": "Bootstrap Defecto",
  "badge.primary": "Primary",
  "badge.secondary": "Secondary",
  "badge.success": "Success",
  "badge.danger": "Danger",
  "badge.warning": "Warning",
  "badge.info": "Info",
  "badge.light": "Light",
  "badge.dark": "Dark",

  /* 07.03.Botones */
  "button.default": "Bootstrap Defecto",
  "button.colors": "Colores",
  "button.rounded": "Botones Redondeado",
  "button.outline": "Contorno",
  "button.states": "Estados",
  "button.sizes": "Tamaños",
  "button.button-groups": "Grupos de Botones",
  "button.large-button": "Botón Grande",
  "button.small-button": "Botón Pequeño",
  "button.extra-small-button": "Botón Extra Pequeño",
  "button.block-button": "Botón de Bloqueo",
  "button.active": "Activo",
  "button.disabled": "Discapacitado",
  "button.basic": "Básico",
  "button.toolbar": "Barra de Herramientas",
  "button.nesting": "Anidando",
  "button.vertical-variation": "Variación Vertical",
  "button.checkbox-radio-button": "Checkbox  y Radio Buttons",
  "button.checkbox": "Checkbox",
  "button.radio": "Radio",
  "button.radio-button": "Radio Button",
  "button.primary": "Primary",
  "button.secondary": "Secondary",
  "button.success": "Success",
  "button.danger": "Danger",
  "button.warning": "Warning",
  "button.info": "Info",
  "button.light": "Light",
  "button.dark": "Dark",
  "button.states-text":
    "Este botón muestra una rueda giratoria durante 2 segundos y un icono de error durante 3 segundos antes de cambiar al estado normal. Estos estados se pueden activar agregando y eliminando clases.",
  "button.click-here": "Haga clic aquí",
  "button.states-text-alternate":
    "Este botón muestra una rueda giratoria durante 2 segundos y un icono de error durante 3 segundos antes de cambiar al estado normal. Estos estados se pueden activar agregando y eliminando clases.",
  "button.primary-link": "Primary Enlace",
  "button.link": "Enlace",
  "button.primary-button": "Primary Botón",
  "button.button": "Botón",
  "button.left": "Izquierda",
  "button.middle": "Centro",
  "button.right": "Derecha",
  "button.dropdown": "Desplegable",
  "button.dropdown-link": "Enlace Desplegable",

  /* 07.04.Tarjetas */
  "cards.icon-card": "Tarjeta de Icono",
  "cards.image-card": "Tarjeta de Imagen",
  "cards.image-overlay-card": "Tarjeta de Superposición de Imágenes",
  "cards.image-card-list": "Lista de Tarjetas de Imagen",
  "cards.tab-card": "Tarjeta de Tab",
  "cards.user-card": "Tarjeta de Usuario",

  /* 07.05.Carrusel */
  "carousel.basic": "Carrusel Básico",
  "carousel.single": "Carrusel Sólo",
  "carousel.without-controls": "Carrusel sin Control",

  /* 07.06.Gráficos */
  "charts.line": "Gráfico de Linea",
  "charts.polar": "Gráfico de Polar",
  "charts.area": "Gráfico de Área",
  "charts.scatter": "Gráfico de Dispersión",
  "charts.bar": "Gráfico de Barras",
  "charts.radar": "Gráfico de Radar",
  "charts.pie": "Gráfico de Circular",
  "charts.doughnut": "Gráfico de Rosquilla",
  "charts.shadow": "Sombra",
  "charts.no-shadow": "Sin Sombra",

  /* 07.07.Colapso */
  "collapse.basic": "Básico",
  "collapse.toggle": "Palanca",
  "collapse.accordion": "Acordeón",
  "collapse.controlled": "Revisado",
  "collapse.uncontrolled": "Sin Control",

  /* 07.08.Desplegables */
  "dropdowns.basic": "Básico",
  "dropdowns.controlled": "Revisado",
  "dropdowns.uncontrolled": "Sin Control",
  "dropdowns.dropdown": "Desplegable",
  "dropdowns.header": "Encabezado",
  "dropdowns.action": "Accion",
  "dropdowns.another-action": "Otra accion",
  "dropdowns.right": "Derecha",
  "dropdowns.left": "Izquierda",
  "dropdowns.drop-directions": "Direcciones de drop",
  "dropdowns.dropright": "Drop Derecha",
  "dropdowns.dropleft": "Drop Izquierda",
  "dropdowns.small-button": "Botón Pequeño",
  "dropdowns.large-button": "Botón Grande",
  "dropdowns.sizing": "Dimensionamiento",
  "dropdowns.split-button": "Botones Desplegables",
  "dropdowns.dropup": "Dropup",

  /* 07.09.Editores */
  "editors.draftjs": "Draft.js",
  "editors.quill-standart": "Quill Estándar",
  "editors.quill-bubble": "Quill Burbuja",

  /* 07.10.Formularios */
  "forms.basic": "Básico",
  "forms.email": "Email",
  "forms.email-muted": "Nunca compartiremos tu email con nadie más.",
  "forms.password": "Contraseña",
  "forms.submit": "Enviar",
  "forms.horizontal": "Horizontal",
  "forms.radios": "Radios",
  "forms.first-radio": "Primero radio",
  "forms.second-radio": "Segundo radio",
  "forms.third-radio-disabled": "Tercera radio deshabilitada",
  "forms.checkbox": "Checkbox",
  "forms.signin": "Registrarse",
  "forms.top-labels-over-line": "Etiquetas Superiores Sobre la Línea",
  "forms.tags": "Etiquetas",
  "forms.date": "Fecha",
  "forms.state": "Estado",
  "forms.top-labels-in-input": "Etiquetas Superiores Sobre la Entrada",
  "forms.email-u": "EMAIL",
  "forms.password-u": "CONTRASEÑA",
  "forms.tags-u": "ETIQUETAS",
  "forms.date-u": "FECHA",
  "forms.state-u": "ESTADO",
  "forms.grid": "Cuadrícula de Formulario",
  "forms.address": "Dirección",
  "forms.address2": "Dirección 2",
  "forms.city": "Ciudad",
  "forms.city-message": "Por favor seleccione una ciudad!",
  "forms.state-message": "Por favor seleccione un estado!",
  "forms.zip": "Código Postal",
  "forms.signup": "Regístrate",
  "forms.inline": "Inline",
  "forms.validation": "Validación",
  "forms.default": "Defecto",
  "forms.firstname": "Nombre de Pila",
  "forms.firstname-message": "¡Por favor, introduzca su nombre de pila!",
  "forms.lastname": "Apellido",
  "forms.lastname-message": "¡Por favor ingrese su apellido!",

  /* 07.11.Componentes */
  "form-components.custom-inputs": "Entrada Personalizada",
  "form-components.checkboxes": "Checkboxes",
  "form-components.radios": "Radios",
  "form-components.inline": "Inline",
  "form-components.react-select": "React Select",
  "form-components.state-single": "Estado Soltero",
  "form-components.state-multiple": "Estado Múltiple",
  "form-components.react-autosuggest": "React Autosuggest",
  "form-components.date-picker": "Selector de Fechas",
  "form-components.date": "Fecha",
  "form-components.date-range": "Rango de Fechas",
  "form-components.date-with-time": "Fecha con Hora",
  "form-components.embedded": "Incrustado",
  "form-components.dropzone": "Dropzone",
  "form-components.drop-files-here": "Soltar Archivos Aquí",
  "form-components.tags": "Etiquetas",
  "form-components.switch": "Cambiar",
  "form-components.primary": "Primary",
  "form-components.secondary": "Secondary",
  "form-components.primary-inverse": "Primary Inverso",
  "form-components.secondary-inverse": "Secondary Inverso",
  "form-components.slider": "Deslizador",
  "form-components.double-slider": "Doble Deslizador",
  "form-components.single-slider": "Único Deslizador",
  "form-components.rating": "Clasificación",
  "form-components.interactive": "Interactivo",
  "form-components.readonly": "Solo Lectura",
  "form-components.type-a-cake": "Escribe un pastel",
  "form-components.start": "Comienzo",
  "form-components.end": "Fin",
  "form-components.tables": "Tablas",
  /* 07.12.Iconos */
  "icons.simplelineicons": "Simple Line Iconos",
  "icons.iconsmind": "Iconsmind Iconos",

  /* 07.13.Grupos de Entrada */
  "input-groups.basic": "Básico",
  "input-groups.sizing": "Dimensionamiento",
  "input-groups.small": "Pequeño",
  "input-groups.default": "Defecto",
  "input-groups.large": "Grande",
  "input-groups.checkboxes-and-radios": "Checkboxes y radios",
  "input-groups.multiple-inputs": "Entradas Múltiples",
  "input-groups.first-and-last-name": "Nombre y apellido",
  "input-groups.multiple-addons": "Complementos Múltiples",
  "input-groups.button-addons": "Complementos Botón",
  "input-groups.button": "Botón",
  "input-groups.buttons-with-dropdowns": "Botones y Desplegables",
  "input-groups.dropdown": "Desplegable",
  "input-groups.header": "Encabezado",
  "input-groups.action": "Accion",
  "input-groups.another-action": "Otra accion",
  "input-groups.custom-select": "Personalizada Select",
  "input-groups.options": "Opciones",
  "input-groups.choose": "Escoger...",
  "input-groups.custom-file-input": "Entrada de Archivo Personalizada",

  /* 07.14.Jumbotron */
  "jumbotron.hello-world": "¡Hola Mundo!",
  "jumbotron.lead":
    "Esta es una unidad de héroe simple, un componente de estilo jumbotron simple para llamar la atención extra al contenido o información destacados.",
  "jumbotron.lead-detail":
    "Utiliza clases de utilidad para tipografía y espaciado para espaciar el contenido dentro del contenedor más grande.",
  "jumbotron.learn-more": "Aprende más",

  /* 07.15.Modal */
  "modal.basic": "Básico",
  "modal.modal-title": "Título Modal",
  "modal.launch-demo-modal": "Lanzar Demo Modal",
  "modal.scrolling-long-content": "Contenido de Desplazamiento Largo",
  "modal.backdrop": "Fondo",
  "modal.backdrop-value": "Valor de Fondo",
  "modal.right-modal": "Derecha Modal",
  "modal.launch-right-modal": "Launch Derecha Modal",
  "modal.nested-modal": "Modal Anidado",
  "modal.size": "Tamaño",
  "modal.launch-large-modal": "Lanzar Grande Modal",
  "modal.launch-small-modal": "Lanzar Pequeño Modal",

  /* 07.16.Navegación */
  "nav.basic": "Navegación Básico",
  "nav.active": "Activo",
  "nav.disabled": "Discapacitado",
  "nav.disabled-link": "Enlace Discapacitado",
  "nav.link": "Enlace",
  "nav.longer-link": "Enlace de navegación más largo",
  "nav.another-link": "Otro Enlace",
  "nav.right": "Derecha",
  "nav.dropdown": "Desplegable",
  "nav.header": "Encabezado",
  "nav.action": "Accion",
  "nav.another-action": "Otra accion",
  "nav.horizontal-alignment": "Alineación Horizontal",
  "nav.vertical-alignment": "Alineación Vertical",
  "nav.pills": "Navegación Píldoras",
  "nav.fill-justify": "Navegación Llenar y Justify",
  "nav.pills-dropdowns": "Nav Pills with Dropdowns",
  "nav.pagination-basic": "Paginación Básico",
  "nav.pagination-sizing": "Paginación Dimensionamiento",
  "nav.large": "Grande",
  "nav.small": "Pequeño",
  "nav.center": "Centro",
  "nav.pagination-alignment": "Alineación de Paginación",
  "nav.breadcrumb-basic": "Migas de Pan Básico",

  /* 07.17.Tooltips y Popovers */
  "popover-tooltip.popover": "Popovers",
  "popover-tooltip.tooltip": "Tooltips",

  /* 07.18.Ordenable */
  "sortable.columns": "Clasificar Columnas",
  "sortable.basic": "Básico",
  "sortable.handles": "Handles",

  /* 07.19.Maps */
  "maps.google": "Google",
  "maps.yandex": "Yandex",

  /* 07.20.Tables */
  "table.bootstrap-tables": "Tablas Bootstrap",
  "table.bootstrap-basic": "Tablas Básicas",
  "table.bootstrap-striped": "Cebreadas",
  "table.bootstrap-bordered": "Tablas Con Bordes",
  "table.bootstrap-borderless": "Tablas Sin Bordes",
  "table.bootstrap-hoverable": "Tablas dinámicas",
  "table.bootstrap-responsive": "Tablas Responsive",
  "table.react-tables": "Tablas React",
  "table.react-pagination": "Paginación",
  "table.react-scrollable": "Tablas Con Voluta",
  "table.react-advanced": "Filtro, Longitud y Salto",

  /* E-Invoice */
  "einvoice.action.issue-official": "Emisión oficial",
  "einvoice.correction.adjust": "Ajustar",
  "einvoice.correction.replace": "Reemplazar",
  "einvoice.correction.edit-draft": "Editar borrador de SePay",
  "einvoice.correction.modal-adjust-title": "Factura de ajuste SePay",
  "einvoice.correction.modal-replace-title": "Factura de sustitución SePay",
  "einvoice.correction.submit": "Enviar a SePay",
  "einvoice.mapping.preview": "Vista previa de sincronización VMASS",
  "einvoice.mapping.applied": "Aplicado",
  "einvoice.mapping.pending": "Pendiente de aplicar",
  "einvoice.mapping.conflict": "Conflicto; cree un nuevo documento",
  "einvoice.mapping.failed": "Error técnico; se reintentará",
  "einvoice.mapping.inventory": "Inventario de factura",
  "einvoice.mapping.inventory-applied": "Ingredientes: {restored} reposiciones, {deducted} deducciones; variantes: {variantsRestored} repuestas, {variantsDeducted} deducidas",
  "einvoice.correction.save-draft": "Guardar borrador en SePay",
  "einvoice.correction.issue-now": "Emitir ahora",

  /* Recipe Builder */
  "recipe.unit.default": "Pcs, caja, paquete...",
  "recipe.unit.cafe": "Taza, vaso, plato...",
  "recipe.unit.fashion": "Pcs, par, juego...",
  "recipe.unit.cosmetics": "Botella, tubo, tarro...",
  "recipe.unit.retail": "Pcs, paquete, caja, kg...",
  "recipe.unit.generic": "unidad",
  "recipe.title": "Receta / Ingredientes",
  "recipe.count-badge": "ingredientes",
  "recipe.empty-state":
    'Aún no hay ingredientes. Haga clic en "Agregar ingrediente" para comenzar.',
  "recipe.label.name": "Nombre del ingrediente",
  "recipe.placeholder.select": "Seleccionar o crear nuevo...",
  "recipe.create-label": 'Crear "{val}"',
  "recipe.label.usage": "Cant. uso",
  "recipe.label.total": "Subtotal",
  "recipe.btn.delete": "Eliminar fila",
  "recipe.btn.delete-tooltip": "Eliminar ingrediente",
  "recipe.new-stock.title": "Importar nuevo stock:",
  "recipe.label.unit": "Unidad",
  "recipe.label.import-qty": "Cant. importada",
  "recipe.label.cost-price": "Precio de coste",
  "recipe.unit.per-unit": " / unidad",
  "recipe.label.paid": "Pagado",
  "recipe.label.provider": "Proveedor",
  "recipe.create-provider": 'Crear "{val}"',
  "recipe.label.debt": "Deuda",
  "recipe.btn.add": "Agregar ingrediente",
  "recipe.footer.total-cost": "Coste total:",
  "recipe.footer.expected-profit": "Beneficio est.:",

  "product.name": "Nombre del Producto",
  "product.price": "Precio",
  "product.promotion-price": "Precio Promoción",
  "product.price.cost": "Precio Coste",
  "product.image": "Imagen",
  "label.enter-barcode": "Introduzca código de barras",
  "label.enter-product-name": "Introduzca nombre del producto",
  "stock.unit": "Unidad",
  "label.select-or-create": "Seleccionar o crear...",
  "label.create-new": "Crear nuevo",
  "label.select-create-provider": "Seleccionar o crear proveedor...",
  "unit.placeholder.default": "Pcs, caja, paquete...",
  "unit.placeholder.cafe": "Taza, vaso, plato...",
  "unit.placeholder.fashion": "Pcs, par, juego...",
  "unit.placeholder.cosmetics": "Botella, tubo, tarro...",
  "unit.placeholder.retail": "Pcs, paquete, caja, kg...",
  "modal.stock.stt": "No.",
  "modal.product.unit": "Receta",
  "modal.product.combo": "Combo",
  "product.edit_cost": "Editar Coste",
  "tooltip.enable-combo": "Habilitar Combo",
  "modal.product.variant": "Variante",
  "tooltip.not-for-combo": "No para Combo",
  "modal.stock.supplier": "Proveedor",
  "modal.product.paid": "Pagado",
  "modal.stock.remaining": "Restante",
  "modal.product.image": "Imagen",
  "tooltip.unit-hint": "Unidad del producto",
  "warehouse.import-quantity": "Cant. Importada",

  "product.add-title": "Añadir Producto",

  /* Warehouse / Finance ApplicationMenu */
  "price.under-1m": "Menos de 1 millón",
  "price.1m-to-10m": "De 1 a 10 millones",
  "price.over-10m": "Más de 10 millones",
  "menu.finance.include-statistics": "Incluir en estadísticas",
  "menu.finance.price-range": "Rango de precios",
  "menu.finance.creator": "Creador",
  "menu.warehouse.status": "Estado",
  "menu.warehouse.quantity-range": "Cantidad",
  "menu.warehouse.unit": "Unidad",
  "quantity.under-10": "Menos de 10",
  "quantity.10-to-50": "De 10 a 50",
  "quantity.over-50": "Más de 50",

  /* Product Multi-Form */
  "product.multi.name": "Nombre del Producto",
  "product.multi.barcode": "Código de barras",
  "product.multi.sku": "SKU",
  "product.multi.unit": "Unidad",
  "product.multi.category": "Categoría",
  "product.multi.hot": "Popular",
  "product.multi.price": "Precio",
  "product.multi.price_sale": "Precio de oferta",
  "product.multi.active_sale": "Oferta activa",
  "product.multi.recipe": "Receta",
  "product.multi.variant": "Variante",
  "product.multi.image": "Imagen",
  "product.multi.soft_hide": "Ocultar",
  /* Shopee */
  "menu.ecommerce": "Comercio electrónico",
  "menu.shopee": "Shopee",
  "menu.tiktok-shop": "TikTok Shop",
  "menu.lazada": "Lazada",
  "menu.tiki": "Tiki",
  "ecommerce.coming-soon": "Próximamente",
  "ecommerce.coming-soon-desc": "Esta función está en desarrollo. ¡Pronto admitiremos esta plataforma!",
  "shopee.tab.connection": "Conexión",
  "shopee.tab.orders": "Pedidos",
  "shopee.tab.products": "Productos",
  "shopee.tab.inventory": "Inventario",
  "shopee.connection.title": "Conexión de Tienda Shopee",
  "shopee.connection.desc": "Conecta tu tienda Shopee para sincronizar pedidos, productos e inventario.",
  "shopee.connect.btn": "Conectar nueva Tienda",
  "shopee.connect.error": "Error al conectar con Shopee",
  "shopee.disconnect.btn": "Desconectar",
  "shopee.disconnect.confirm": "¿Estás seguro de que quieres desconectar esta tienda?",
  "shopee.disconnect.success": "Tienda desconectada exitosamente",
  "shopee.disconnect.error": "Error al desconectar la tienda",
  "shopee.oauth.success": "La tienda Shopee se conectó correctamente.",
  "shopee.oauth.error.missing-params": "Shopee no devolvió todos los datos de autorización requeridos.",
  "shopee.oauth.error.invalid-state": "La sesión de conexión de Shopee no es válida o ha caducado. Inténtalo de nuevo.",
  "shopee.oauth.error.not-configured": "Las credenciales de Shopee Partner no están configuradas.",
  "shopee.oauth.error.shop-already-connected": "Esta tienda Shopee está conectada a otra cuenta de VMASS.",
  "shopee.oauth.error.callback-failed": "No se pudo completar la conexión con Shopee. Inténtalo de nuevo.",
  "shopee.oauth.error.upgrade-required": "Actualiza tu plan para usar la integración con Shopee.",
  "shopee.oauth.error.generic": "Shopee rechazó la solicitud de conexión. Inténtalo de nuevo.",
  "shopee.no-shop": "No hay tiendas Shopee conectadas.",
  "shopee.select-shop": "Seleccionar tienda",
  "shopee.table.name": "Nombre",
  "shopee.table.id": "ID",
  "shopee.table.region": "Región",
  "shopee.table.token-expires": "Estado Token",
  "shopee.table.connected": "Fecha",
  "shopee.token.expired": "Expirado",
  "shopee.token.active": "Activo",
  "shopee.orders.filter.all": "Todos los estados",
  "shopee.orders.sync-btn": "Sincronizar desde Shopee",
  "shopee.orders.bulk-sync": "Sincronizar todo a VMASS",
  "shopee.orders.sync.error": "Error al sincronizar pedidos",
  "shopee.orders.sync-to-bill": "Sincronizar a VMASS",
  "shopee.orders.sync-bill.error": "Error al sincronizar pedido",
  "shopee.orders.load.error": "Error al cargar pedidos",
  "shopee.orders.empty": "No hay pedidos.",
  "shopee.orders.col.sn": "Pedido #",
  "shopee.orders.col.status": "Estado",
  "shopee.orders.col.buyer": "Comprador",
  "shopee.orders.col.amount": "Monto",
  "shopee.orders.col.date": "Fecha",
  "shopee.orders.col.synced": "Sincronizado",
  "shopee.synced": "Sincronizado",
  "shopee.not-synced": "No sincronizado",
  "shopee.products.mapped": "Mapeo de Productos",
  "shopee.products.view-shopee": "Ver en Shopee",
  "shopee.products.import-btn": "Importar de Shopee",
  "shopee.products.load.error": "Error al cargar productos",
  "shopee.products.import.error": "Error al importar productos",
  "shopee.products.empty": "Sin mapeo de productos.",
  "shopee.products.col.name": "Nombre",
  "shopee.products.col.sku": "SKU",
  "shopee.products.col.price": "Precio",
  "shopee.products.col.stock": "Stock",
  "shopee.products.col.vmass": "VMASS",
  "shopee.products.linked": "Vinculado",
  "shopee.products.not-linked": "Sin vincular",
  "shopee.products.map-btn": "Vincular",
  "shopee.products.map.success": "Producto vinculado",
  "shopee.products.map.error": "Error al vincular",
  "shopee.products.map-modal.title": "Vincular producto Shopee con VMASS",
  "shopee.products.map-modal.select": "Seleccionar producto VMASS",
  "shopee.products.map-modal.placeholder": "Elegir producto",
  "shopee.products.map-modal.save": "Guardar",
  "shopee.cancel": "Cancelar",
  "shopee.inventory.title": "Sincronización de Inventario",
  "shopee.inventory.desc": "Enviar stock de VMASS a Shopee.",
  "shopee.inventory.sync-btn": "Sincronizar inventario",
  "shopee.inventory.sync.error": "Error al sincronizar inventario",
  "shopee.inventory.no-linked": "Sin productos vinculados.",
  "shopee.inventory.col.shopee-stock": "Stock Shopee",
  "shopee.inventory.col.vmass-product": "Producto VMASS",
  "shopee.inventory.col.sync-enabled": "Sync",
  "shopee.inventory.col.last-sync": "Última sync",
  "shopee.logistics.ship-btn": "Enviar",
  "shopee.logistics.track-btn": "Rastrear",
  "shopee.logistics.ship.error": "Error al enviar",
  "shopee.logistics.track.error": "Error al rastrear",
  "shopee.logistics.modal.title": "Logística",
  "shopee.logistics.phone": "Teléfono",
  "shopee.logistics.address": "Dirección",
  "shopee.logistics.carrier": "Transportista",
  "shopee.logistics.tracking-no": "N° seguimiento",
  "shopee.logistics.arrange": "Programar envío",
  "shopee.logistics.pickup-address": "Dirección de recogida",
  "shopee.logistics.confirm-ship": "Confirmar envío",
  "shopee.logistics.timeline": "Seguimiento",
  "shopee.logistics.no-tracking": "Sin información de seguimiento.",
  "shopee.tab.returns": "Devoluciones",
  "shopee.tab.analytics": "Análisis",
  "shopee.tab.settings": "Configuración",
  "shopee.tab.monitor": "Monitor",
  "shopee.returns.title": "Devoluciones y Reembolsos",
  "shopee.returns.refresh": "Actualizar",
  "shopee.returns.empty": "No hay solicitudes de devolución/reembolso.",
  "shopee.returns.col.sn": "N° Devolución",
  "shopee.returns.col.order": "N° Pedido",
  "shopee.returns.col.reason": "Razón",
  "shopee.returns.col.status": "Estado",
  "shopee.returns.col.amount": "Monto Reembolso",
  "shopee.returns.col.date": "Fecha",
  "shopee.returns.col.buyer": "Comprador",
  "shopee.returns.accept": "Aceptar",
  "shopee.returns.dispute": "Disputar",
  "shopee.returns.load.error": "Error al cargar devoluciones",
  "shopee.returns.detail.error": "Error al cargar detalle",
  "shopee.returns.detail.title": "Detalle de Devolución",
  "shopee.returns.confirm.prompt": "¿Está seguro de aceptar esta devolución?",
  "shopee.returns.confirm.error": "Error al confirmar devolución",
  "shopee.returns.dispute.title": "Disputar Devolución",
  "shopee.returns.dispute.email": "Email de Contacto",
  "shopee.returns.dispute.reason": "Razón de Disputa",
  "shopee.returns.dispute.submit": "Enviar Disputa",
  "shopee.returns.dispute.success": "Disputa enviada correctamente",
  "shopee.returns.dispute.error": "Error al enviar disputa",
  "shopee.returns.buyer-note": "Nota del comprador",
  "shopee.analytics.title": "Análisis Shopee",
  "shopee.analytics.no-data": "Sin datos de análisis.",
  "shopee.analytics.total-orders": "Total Pedidos",
  "shopee.analytics.revenue": "Ingresos",
  "shopee.analytics.synced": "Sincronizado a VMASS",
  "shopee.analytics.products-linked": "Productos Vinculados",
  "shopee.analytics.by-status": "Pedidos por Estado",
  "shopee.analytics.last-7-days": "Últimos 7 Días",
  "shopee.analytics.col.date": "Fecha",
  "shopee.analytics.col.orders": "Pedidos",
  "shopee.analytics.col.revenue": "Ingresos",
  "shopee.analytics.date-range": "Rango de fechas",
  "shopee.analytics.date-hint": "Los datos de Shopee no pueden buscarse más allá de 90 días (3 meses). Seleccione un rango.",
  "shopee.analytics.max-range": "El rango no puede superar 90 días (3 meses)",
  "shopee.analytics.invalid-range": "La fecha de inicio debe ser anterior a la fecha final",
  "shopee.settings.title": "Configuración Shopee",
  "shopee.settings.auto-sync-orders": "Sincronización automática",
  "shopee.settings.auto-sync-orders.desc": "Sincronizar pedidos nuevos automáticamente",
  "shopee.settings.sync-interval": "Intervalo de sincronización",
  "shopee.settings.sync-interval.desc": "Frecuencia de verificación de pedidos nuevos",
  "shopee.settings.auto-bill": "Crear factura automática",
  "shopee.settings.auto-bill.desc": "Crear facturas VMASS desde pedidos Shopee",
  "shopee.settings.auto-inventory": "Sincronizar inventario automático",
  "shopee.settings.auto-inventory.desc": "Enviar inventario VMASS a Shopee automáticamente",
  "shopee.settings.notifications": "Notificaciones",
  "shopee.settings.notify-new-order": "Pedido nuevo",
  "shopee.settings.notify-status": "Cambio de estado",
  "shopee.settings.notify-return": "Solicitud de devolución",
  "shopee.settings.save": "Guardar",
  "shopee.settings.save.success": "Configuración guardada",
  "shopee.settings.save.error": "Error al guardar",
  "shopee.monitor.health": "Estado de Conexión",
  "shopee.monitor.no-shops": "Sin tiendas conectadas.",
  "shopee.monitor.last-sync": "Última sincr.",
  "shopee.monitor.expiring-soon": "Por vencer",
  "shopee.monitor.activity": "Registro de Actividad",
  "shopee.monitor.filter.all": "Toda la actividad",
  "shopee.monitor.no-activity": "Sin actividad reciente.",
  "shopee.push.modal.title": "Publicar producto en Shopee",
  "shopee.push.step": "Paso",
  "shopee.push.step.select": "Seleccionar producto VMASS",
  "shopee.push.step.category": "Elegir categoría Shopee",
  "shopee.push.step.details": "Detalles del producto",
  "shopee.push.step.confirm": "Revisar y publicar",
  "shopee.push.form.name": "Nombre del producto (5-120 caracteres)",
  "shopee.push.form.description": "Descripción (mín. 25 caracteres)",
  "shopee.push.form.price": "Precio",
  "shopee.push.form.weight": "Peso (kg)",
  "shopee.push.form.condition": "Condición",
  "shopee.push.form.condition.new": "Nuevo",
  "shopee.push.form.condition.used": "Usado",
  "shopee.push.form.status": "Estado de publicación",
  "shopee.push.form.status.normal": "Activo (NORMAL)",
  "shopee.push.form.status.unlist": "Oculto (UNLIST)",
  "shopee.push.form.logistics": "Canales de envío",
  "shopee.push.form.attributes": "Atributos de categoría",
  "shopee.push.form.category": "Categoría Shopee",
  "shopee.push.form.dimension": "Dimensiones del paquete",
  "shopee.push.btn.next": "Siguiente",
  "shopee.push.btn.back": "Atrás",
  "shopee.push.btn.push": "Publicar en Shopee",
  "shopee.push.btn.push-short": "Publicar en Shopee",
  "shopee.push.btn.select": "Seleccionar",
  "shopee.push.btn.cancel": "Cancelar",
  "shopee.push.validate.name": "El nombre debe tener entre 5 y 120 caracteres",
  "shopee.push.validate.description": "La descripción debe tener al menos 25 caracteres",
  "shopee.push.validate.price": "El precio debe ser mayor a 0",
  "shopee.push.validate.weight": "El peso debe estar entre 0.01 y 50 kg",
  "shopee.push.validate.category": "Seleccione una categoría",
  "shopee.push.validate.logistics": "Seleccione al menos un canal de envío",

  "suggestion.title": "Sugerencias",
  "suggestion.frequently-bought": "Comprados juntos",
  "suggestion.bestseller": "Más vendido",

  /* Shift Session */
  "menu.shift-session": "Cierre de turno",
  "menu.tax-accounting": "Contabilidad & Impuestos",
  "menu.ai-copilot": "Asistente AI",
  "shift.title": "Gestión de turnos",
  "shift.open": "Abrir turno",
  "shift.close": "Cerrar turno",
  "shift.current": "Turno actual",
  "shift.history": "Historial de turnos",
  "shift.no-open": "No hay ningún turno abierto actualmente",
  "shift.open-hint": 'Presione "Abrir turno" para iniciar un nuevo turno',
  "shift.open-modal-title": "Abrir turno de trabajo",
  "shift.close-modal-title": "Cerrar turno y conciliación de caja",
  "shift.detail-modal-title": "Detalles del turno",
  "shift.shift-name": "Nombre del turno",
  "shift.shift-name-placeholder": "Ej: Turno mañana, Turno tarde...",
  "shift.staff-name": "Empleado",
  "shift.opened-at": "Hora de apertura",
  "shift.closed-at": "Hora de cierre",
  "shift.opening-cash": "Efectivo inicial",
  "shift.opening-cash-hint": "Efectivo en caja al inicio del turno",
  "shift.actual-cash": "Efectivo real al final del turno",
  "shift.actual-cash-placeholder": "Ingrese el efectivo contado",
  "shift.expected-cash": "Efectivo teórico",
  "shift.cash-difference": "Diferencia",
  "shift.total-revenue": "Ingresos totales",
  "shift.total-cash": "Efectivo",
  "shift.total-transfer": "Transferencia bancaria",
  "shift.total-card": "Tarjeta de crédito",
  "shift.total-credit": "Crédito",
  "shift.total-orders": "Total de pedidos",
  "shift.total-products": "Total de productos",
  "shift.note": "Nota",
  "shift.note-optional": "Nota (opcional)",
  "shift.note-explain": "Explicar diferencia",
  "shift.note-explain-required":
    "Obligatorio - Ingrese la razón de la diferencia de caja",
  "shift.status": "Estado",
  "shift.status-open": "Abierto",
  "shift.status-closed": "Cerrado",
  "shift.confirm-open": "Confirmar apertura de turno",
  "shift.confirm-close": "Confirmar cierre de turno",
  "shift.require-open": "Por favor abra un turno antes de vender",
  "shift.print": "Imprimir informe de turno",
  "shift.print-title": "INFORME DE CIERRE DE TURNO",
  "shift.revenue-in-shift": "Ingresos del turno",
  "shift.cash-reconciliation": "Conciliación de caja",
  "shift.cash-revenue-add": "+ Ingresos en efectivo",
  "shift.expected-cash-equals": "= Efectivo teórico",
  "shift.no-data": "No hay datos de turnos disponibles",
  "shift.detail": "Detalles",
  "shift.page-prev": "← Anterior",
  "shift.page-next": "Siguiente →",
  "shift.page-of": "Página {current} / {total}",
  "shift.open-success": "Turno abierto exitosamente",
  "shift.close-success": "Turno cerrado exitosamente",
  "shift.open-error": "Error al abrir el turno",
  "shift.close-error": "Error al cerrar el turno",
  "shift.close-warn-difference":
    "Hay una diferencia de caja. Por favor ingrese una explicación antes de cerrar el turno.",
  "shift.store-name": "Tienda",
  "shift.copyright": "Derechos reservados vmass.vn",
  "shift.cancel": "Cancelar",
  "fb.comment.no-posts": "No se encontraron publicaciones",
  "fb.comment.no-posts-hint": "Haga clic en \"Sincronizar\" para cargar desde Fanpage",
  "fb.comment.loading-comments": "Cargando comentarios...",
  "fb.comment.no-comments": "No se encontraron comentarios",
  "fb.comment.select-post": "Seleccione una publicación para ver los comentarios",
  "fb.comment.post-detail": "Detalles de la publicación",
  "fb.comment.view-on-fb": "Ver en Facebook",
  "fb.comment.like": "Me gusta",
  "fb.comment.reply": "Responder",
  "fb.comment.hide": "Ocultar",
  "fb.comment.unhide": "Mostrar",
  "fb.comment.hidden": "Oculto",
  "fb.comment.reply-placeholder": "Escriba una respuesta...",
  "fb.comment.edit": "Editar",
  "fb.comment.delete": "Eliminar",
  "fb.comment.filter-all": "Todos",
  "fb.comment.filter-unread": "No leídos",
  "fb.comment.filter-unreplied": "Sin respuesta",
  "fb.comment.status-replied": "Respondido",
  "fb.comment.loading-posts": "Cargando publicaciones...",
  "fb.comment.no-pages-desc": "Aún no hay Fanpages conectadas a VMASS. Utilice tokens de acceso para administrar comentarios.",
  "analytics.user-staff": "Personal",
  "analytics.staff.sales": "Ventas",
  "analytics.staff.bill_count": "Pedidos",
  "analytics.staff.product_count": "Productos",
  "analytics.staff.commission": "Comisión",
  "pages.add-new-log": "Agregar registro",
  "address": "Dirección",
  "user-staff.title": "Información del personal",
  "user-staff.add-new-modal-title": "Agregar personal",
  "user-staff.add-new-logs-modal-title": "Agregar otro",
  "user-staff.permission_name": "Puesto",
  "user-staff.date_join": "Fecha de ingreso",
  "user-staff.date_get_salary": "Día de pago",
  "user-staff.hour_working_on_day": "Horas de trabajo por día",
  "user-staff.status_working": "Estado laboral",
  "user-staff.salary_by": "Calcular salario por",
  "user-staff.salary_value": "Salario",
  "user-staff.working_hours": "Horario de trabajo",
  "user-staff.current_commission": "Comisión",
  "user-staff.current_bonus": "Bono",
  "user-staff.current_overtime": "Horas extra",
  "user-staff.current_advence": "Anticipo",
  "user-staff.current_fined": "Multa",
  "user-staff.current_dayoff": "Permiso",
  "user-staff.current_day_working": "Días trabajados este mes",
  "user-staff.current_salary": "Salario este mes",
  "user-staff.total_salary": "Salario total",
  "user-staff.total_day_working": "Total días trabajados",
  "user-staff.working_hours_from": "* Trabaja desde",
  "user-staff.working_hours_to": "* Trabaja hasta",
  "user-staff.logs_users_staff": "Nombre",
  "user-staff.logs_type": "Tipo",
  "user-staff.logs_value_salary": "Importe",
  "user-staff.logs_value_hour": "Hora",
  "user-staff.overtime_coefficient": "Coeficiente de horas extra",
  "user-staff.select-all-users": "Elegir personal",
  "user-staff.select-one": "Elegir un tipo",
  "user-staff.name": "Nombre",
  "user-staff.phone": "Teléfono",
  "user-staff.address": "Dirección",
  "user-staff.email": "Email",
  "user-staff.search": "Buscar por nombre",
  "user-staff.btn-add": "Crear",
  "user-staff.add-log-title": "Agregar información de nómina",
  "user-staff.kpi.total": "Total personal",
  "user-staff.kpi.active": "Trabajando",
  "user-staff.kpi.inactive": "Inactivo",
  "user-staff.kpi.manager": "Gerentes",
  "user-staff.kpi.revenue-today": "Ingresos de hoy",
  "user-staff.kpi.current": "Datos actuales",
  "user-staff.kpi.current-page": "Página actual",
  "user-staff.kpi.today": "Hoy",
  "user-staff.search-placeholder": "Buscar personal...",
  "user-staff.filter.position-all": "Puesto: Todos",
  "user-staff.filter.status-all": "Estado: Todos",
  "user-staff.filter.shift-all": "Turno: Todos",
  "user-staff.filter.clear": "Filtro",
  "user-staff.table.employee": "Empleado",
  "user-staff.table.position": "Puesto",
  "user-staff.table.shift": "Turno",
  "user-staff.table.phone": "Teléfono",
  "user-staff.table.revenue-today": "Ingresos de hoy",
  "user-staff.table.bills": "Facturas",
  "user-staff.table.status": "Estado",
  "user-staff.table.action": "Acción",
  "user-staff.action.call": "Llamar",
  "user-staff.action.message": "Mensaje",
  "user-staff.action.edit": "Editar",
  "user-staff.action.more": "Más",
  "user-staff.action.delete": "Eliminar",
  "user-staff.empty": "No hay datos del personal",
  "user-staff.detail.empty": "Seleccione un empleado para ver detalles",
  "user-staff.detail.tab.info": "Información",
  "user-staff.detail.tab.schedule": "Horario",
  "user-staff.detail.tab.performance": "Rendimiento",
  "user-staff.detail.tab.salary": "Nómina",
  "user-staff.detail.tab.permission": "Permisos",
  "user-staff.detail.basic": "Información básica",
  "user-staff.detail.staff-code": "Código de empleado",
  "user-staff.detail.birthday": "Fecha de nacimiento",
  "user-staff.detail.schedule": "Horario",
  "user-staff.detail.performance": "Rendimiento de hoy",
  "user-staff.detail.salary": "Nómina",
  "user-staff.detail.permission": "Permisos",
  "user-staff.detail.dynamic-fields": "Campos personalizados",
  "user-staff.today.revenue": "Ingresos",
  "user-staff.today.bills": "Facturas",
  "user-staff.today.products": "Productos atendidos",
  "user-staff.today.revenue-per-hour": "Ingresos/hora",
  "user-staff.total.revenue": "Ingresos totales",
  "analytics.summary.customer_debt": "Deuda de clientes",
  "menu.cash-flow": "Flujo de caja",
  "analytics.cash-flow": "Flujo de caja",
  "topnav.search.placeholder.cash-flow": "Buscar ingresos y gastos...",
  "analytics.product_customers.title": "Clientes que compraron",
  "analytics.product_customers.identified": "Clientes identificados",
  "analytics.product_customers.anonymous": "Pedidos de invitados",
  "analytics.product_customers.quantity": "Cantidad",
  "analytics.product_customers.revenue": "Ingresos",
  "analytics.product_customers.search": "Buscar",
  "analytics.product_customers.customer": "Cliente",
  "analytics.product_customers.orders": "Pedidos",
  "analytics.product_customers.spent": "Gasto",
  "analytics.product_customers.last_purchase": "Última compra",
  "analytics.product_customers.empty": "No hay clientes coincidentes",
  "analytics.product_customers.customers": "clientes",
  "analytics.summary.total_products_sold_period": "Productos vendidos en el período",
  "analytics.summary.total_quantity_sold_period": "Cantidad vendida en el período",
  "analytics.summary.product_revenue_period": "Ingresos por productos",
  "analytics.summary.product_cost_period": "Costo de productos",
  "analytics.summary.product_gross_profit_period": "Beneficio bruto",
  "analytics.summary.product_margin_period": "Margen de beneficio",
  "shopee.workspace.title": "Centro de operaciones de Shopee",
  "shopee.workspace.subtitle": "Pedidos, catálogo, inventario, envíos y liquidaciones por tienda",
  "shopee.workspace.overview": "Resumen",
  "shopee.workspace.catalog": "Catálogo",
  "shopee.workspace.inventory": "Inventario",
  "shopee.workspace.fulfillment": "Envíos",
  "shopee.workspace.returns": "Devoluciones",
  "shopee.workspace.finance": "Finanzas",
  "shopee.workspace.automation": "Automatización",
  "shopee.workspace.logs": "Registros",
  "shopee.workspace.refresh": "Actualizar",
  "shopee.workspace.search": "Buscar",
  "shopee.workspace.from-date": "Desde",
  "shopee.workspace.to-date": "Hasta",
  "shopee.workspace.loading": "Cargando datos de Shopee…",
  "shopee.workspace.no-data": "No hay datos",
  "shopee.workspace.actions": "Acciones",
  "shopee.workspace.gmv": "GMV",
  "shopee.workspace.refunds": "Reembolsos",
  "shopee.workspace.fees": "Tarifas de Shopee",
  "shopee.workspace.net-revenue": "Ingresos netos",
  "shopee.workspace.payout": "Pago recibido",
  "shopee.workspace.issues": "Problemas",
  "shopee.workspace.issue-center": "Centro de problemas",
  "shopee.workspace.order-issues": "pedidos pendientes",
  "shopee.workspace.mapping-issues": "mapeos pendientes",
  "shopee.workspace.job-issues": "tareas fallidas",
  "shopee.workspace.retry-selected-orders": "Reintentar pedidos seleccionados",
  "shopee.workspace.auto-map-selected": "Mapear SKU exactos",
  "shopee.workspace.create-selected-drafts": "Crear borradores seleccionados",
  "shopee.workspace.issue-reason": "Problema",
  "shopee.workspace.item-model": "Artículo / modelo",
  "shopee.workspace.job": "Tarea",
  "shopee.workspace.replay": "Reintentar",
  "shopee.workspace.no-issues": "No se encontraron problemas",
  "shopee.workspace.confirm-remediation": "Confirmar corrección",
  "shopee.workspace.confirm-remediation-detail": "Esta acción solo procesa los registros seleccionados y es idempotente.",
  "shopee.workspace.sync": "Sincronizar",
  "shopee.workspace.mapping": "Mapeo",
  "shopee.workspace.sync-state": "Estado de sincronización",
  "shopee.workspace.amount": "Importe",
  "shopee.workspace.create-bill": "Crear factura",
  "shopee.workspace.import-catalog": "Importar catálogo",
  "shopee.workspace.map-product": "Vincular producto",
  "shopee.workspace.mapping-wizard": "Vincular variante de Shopee con VMASS",
  "shopee.workspace.search-product": "Buscar productos VMASS",
  "shopee.workspace.choose-product": "Elegir un producto VMASS",
  "shopee.workspace.choose-variant": "Elegir una variante VMASS",
  "shopee.workspace.create-draft": "Crear borrador VMASS",
  "shopee.workspace.update-listing": "Actualizar publicación",
  "shopee.workspace.list-listing": "Publicar",
  "shopee.workspace.unlist-listing": "Ocultar",
  "shopee.workspace.variant-prices": "Precios por variante",
  "shopee.workspace.image-urls": "URL de imágenes",
  "shopee.workspace.image-help": "Una URL de activo VMASS permitida por línea; solo se envían si se edita este campo.",
  "shopee.workspace.length": "Largo (cm)",
  "shopee.workspace.width": "Ancho (cm)",
  "shopee.workspace.height": "Alto (cm)",
  "shopee.workspace.vmass-product-id": "ID de producto VMASS",
  "shopee.workspace.vmass-variant-id": "ID de variante VMASS (vacío para producto simple)",
  "shopee.workspace.mapping-help": "El sistema verifica el tenant y la pertenencia de la variante antes de guardar.",
  "shopee.workspace.sync-stock": "Sincronizar stock",
  "shopee.workspace.shopee-stock": "Stock Shopee",
  "shopee.workspace.state": "Estado",
  "shopee.workspace.reservation": "Reserva",
  "shopee.workspace.tracking": "Seguimiento",
  "shopee.workspace.ship": "Enviar",
  "shopee.workspace.ship-confirm": "Confirmar envío",
  "shopee.workspace.shipping-params-error": "No se pudieron cargar los parámetros de envío",
  "shopee.workspace.shipping-method": "Método de entrega",
  "shopee.workspace.pickup-address": "Dirección de recogida",
  "shopee.workspace.pickup-time": "Hora de recogida",
  "shopee.workspace.confirm": "Confirmar",
  "shopee.workspace.accept": "Aceptar",
  "shopee.workspace.dispute": "Disputar",
  "shopee.workspace.return-reason": "Motivo de la devolución",
  "shopee.workspace.return-evidence": "Pruebas (ID de imagen separados por comas)",
  "shopee.workspace.sync-finance": "Sincronizar liquidaciones",
  "shopee.workspace.create-income": "Crear recibo",
  "shopee.workspace.save": "Guardar",
  "shopee.workspace.sync-interval": "Intervalo (minutos)",
  "shopee.workspace.resource": "Recurso",
  "shopee.workspace.attempts": "Intentos",
  "shopee.workspace.created-at": "Creado",
  "shopee.workspace.retry": "Reintentar",
  "shopee.workspace.setting.auto_sync_orders": "Sincronizar pedidos automáticamente",
  "shopee.workspace.setting.auto_create_bill": "Crear factura al preparar el envío",
  "shopee.workspace.setting.auto_sync_inventory": "Sincronizar inventario automáticamente",
  "shopee.workspace.setting.auto_sync_catalog": "Sincronizar automáticamente el catálogo de productos",
  "shopee.workspace.catalog-sync-interval": "Intervalo de sincronización del catálogo (minutos)",
  "shopee.workspace.catalog-sync-hint": "De 60 a 10080 minutos; valor predeterminado: 1440 minutos (diario).",
  "shopee.workspace.catalog-last-sync": "Última sincronización correcta del catálogo",
  "shopee.workspace.catalog-next-sync": "Próxima sincronización del catálogo",
  "shopee.workspace.select-shop-for-automation": "Seleccione una tienda específica para configurar la automatización.",
  "shopee.workspace.select-shop-for-listing": "Seleccione una tienda específica antes de añadir o editar productos.",
  "shopee.workspace.listing-load-incomplete": "No se pudieron cargar todos los datos de productos de Shopee. Puede revisar los datos disponibles y volver a intentarlo.",
  "shopee.workspace.listing-no-candidates": "No hay productos VMASS disponibles para publicar en Shopee.",
  "shopee.workspace.setting.notify_new_order": "Notificar nuevos pedidos de Shopee",
  "shopee.workspace.setting.notify_status_change": "Notificar cambios de estado del pedido",
  "shopee.workspace.setting.notify_return": "Notificar devoluciones",
  "shopee.workspace.inventory-safety-buffer": "Stock de seguridad no publicado en Shopee",
  "shopee.workspace.scope-not-granted": "La tienda no ha concedido el permiso de Shopee requerido:",
  "shopee.workspace.group.overview": "RESUMEN",
  "shopee.workspace.group.catalog": "STOCK Y PRODUCTOS",
  "shopee.workspace.group.logistics": "ENVÍOS Y FINANZAS",
  "shopee.workspace.group.system": "SISTEMA",
  "shopee.workspace.tab.overview": "Resumen",
  "shopee.workspace.tab.orders": "Pedidos",
  "shopee.workspace.tab.products": "Productos multicanal",
  "shopee.workspace.tab.mappings": "Vinculación de productos",
  "shopee.workspace.tab.inventory": "Stock por canal",
  "shopee.workspace.tab.pricing": "Precios por canal",
  "shopee.workspace.tab.shipping": "Envíos y embalaje",
  "shopee.workspace.tab.returns": "Devoluciones y reembolsos",
  "shopee.workspace.tab.reconciliation": "Conciliación y pagos",
  "shopee.workspace.tab.issues": "Centro de incidencias",
  "shopee.workspace.tab.connections": "Canales y conexiones",
  "shopee.workspace.tab.connections-short": "Canal de venta",
  "shopee.workspace.tab.automation": "Automatización",
  "shopee.workspace.tab.logs": "Registro de tareas",
  "shopee.workspace.connect-required.title": "Se requiere conectar la cuenta de Shopee",
  "shopee.workspace.connect-required.desc": "Tu cuenta aún no está conectada a ninguna tienda de Shopee. Conecta una tienda de Shopee para ver informes, gestionar pedidos y productos, y sincronizar el inventario.",
  "shopee.workspace.connect-required.feature.orders": "Sincronización automática de pedidos",
  "shopee.workspace.connect-required.feature.mapping": "Vinculación de SKU y gestión de inventario",
  "shopee.workspace.connect-required.feature.shipping": "Actualización del estado de envío",
  "shopee.workspace.connect-required.feature.finance": "Conciliación de ingresos y pagos",
  "shopee.workspace.connect-required.connecting": "Conectando...",
  "shopee.workspace.connect-required.cta": "🚀 Conecta tu tienda de Shopee ahora",
  "shopee.workspace.sidebar.shops-header": "Tiendas",
  "shopee.workspace.sidebar.add-shop-title": "Conectar una nueva tienda de Shopee",
  "shopee.workspace.sidebar.refresh-title": "Actualizar datos",
  "shopee.workspace.sidebar.all-shops": "📊 Todas las tiendas ({count})",
  "shopee.workspace.sidebar.shop-fallback": "Tienda {shopId}",
  "shopee.workspace.sidebar.connected-count": "{count} canales conectados",
  "shopee.workspace.sidebar.not-connected": "Sin conexión",
  "shopee.workspace.common.sending-request": "Enviando solicitud...",
  "shopee.workspace.common.sync": "Sincronizar",
  "shopee.workspace.common.edit": "Editar",
  "shopee.workspace.common.per-page": "{size} / página",
  "shopee.workspace.common.product-name": "Nombre del producto",
  "shopee.workspace.common.customer": "Cliente",
  "shopee.workspace.common.previous": "Anterior",
  "shopee.workspace.common.next": "Siguiente",
  "shopee.workspace.common.loading": "Cargando...",
  "shopee.workspace.common.page": "Página",
  "shopee.workspace.common.of": "de",
  "shopee.workspace.common.rows": "filas",
  "shopee.workspace.common.all-statuses": "Todos los estados",
  "shopee.workspace.common.all-channels": "Todos los canales",
  "shopee.workspace.common.filter": "Filtros",
  "shopee.workspace.common.tab-all-count": "Todas ({count})",
  "shopee.workspace.common.view-all": "Ver todo",
  "shopee.workspace.common.total": "Total",
  "shopee.workspace.common.note": "Nota",
  "shopee.workspace.common.optional": "opcional",
  "shopee.workspace.common.note-placeholder": "Escribe una nota...",
  "shopee.workspace.common.last-7-days": "Últimos 7 días",
  "shopee.workspace.common.last-30-days": "Últimos 30 días",
  "shopee.workspace.catalog.channel-all": "Todos",
  "shopee.workspace.catalog.not-synced-yet": "Sin sincronizar",
  "shopee.workspace.catalog.minutes-ago": "Hace {count} minutos",
  "shopee.workspace.catalog.hours-ago": "Hace {count} horas",
  "shopee.workspace.catalog.channel-unlisted": "No publicado",
  "shopee.workspace.catalog.publish-now": "Publicar ahora",
  "shopee.workspace.catalog.sync-error-short": "Error de sincronización",
  "shopee.workspace.catalog.out-of-stock": "Agotado",
  "shopee.workspace.catalog.listed": "Publicado",
  "shopee.workspace.catalog.view-error": "Ver error",
  "shopee.workspace.catalog.mapping-saved": "Vinculación de producto actualizada",
  "shopee.workspace.catalog.mapping-cleared": "Vinculación del producto de Shopee eliminada de VMASS",
  "shopee.workspace.catalog.inventory-sync-queued": "Sincronización de inventario programada",
  "shopee.workspace.catalog.import-queued": "Importación de catálogo programada",
  "shopee.workspace.catalog.kpi-total-listings": "Total de publicaciones",
  "shopee.workspace.catalog.kpi-total-listings-note": "{count} filas de vinculación",
  "shopee.workspace.catalog.kpi-mapped": "Vinculados",
  "shopee.workspace.catalog.kpi-page-percent": "{percent}% en la página",
  "shopee.workspace.catalog.kpi-unmapped": "Sin vincular",
  "shopee.workspace.catalog.note-needs-action": "Requiere acción",
  "shopee.workspace.catalog.kpi-sync-errors": "Errores de sincronización",
  "shopee.workspace.catalog.note-priority": "Prioridad de atención",
  "shopee.workspace.catalog.kpi-out-of-stock": "Agotados",
  "shopee.workspace.catalog.note-at-shopee": "En el canal Shopee",
  "shopee.workspace.catalog.kpi-price-pending": "Actualización de precio pendiente",
  "shopee.workspace.catalog.note-sync-price": "Sincronización de precio necesaria",
  "shopee.workspace.catalog.filter-aria": "Filtros de producto",
  "shopee.workspace.catalog.search-placeholder": "Buscar productos, SKU, código de barras...",
  "shopee.workspace.catalog.channel-aria": "Canal de venta",
  "shopee.workspace.catalog.mapping-state-aria": "Estado de vinculación",
  "shopee.workspace.catalog.sync-state-aria": "Estado de sincronización",
  "shopee.workspace.catalog.mapping-all": "Todas las vinculaciones",
  "shopee.workspace.catalog.mapping-mapped": "Vinculados",
  "shopee.workspace.catalog.mapping-unmapped": "Sin vincular",
  "shopee.workspace.catalog.sync-state-all": "Estado de sincronización",
  "shopee.workspace.catalog.sync-state-error": "Con errores",
  "shopee.workspace.catalog.add-product": "Añadir producto",
  "shopee.workspace.catalog.select-all-aria": "Seleccionar todos los productos",
  "shopee.workspace.catalog.col-product": "Producto",
  "shopee.workspace.catalog.col-sku-vmass": "SKU VMASS",
  "shopee.workspace.catalog.col-price": "Precio de venta",
  "shopee.workspace.catalog.col-stock": "Stock",
  "shopee.workspace.catalog.col-sync-state": "Estado de sincronización",
  "shopee.workspace.catalog.col-last-update": "Última actualización",
  "shopee.workspace.catalog.select-row-aria": "Seleccionar {name}",
  "shopee.workspace.catalog.no-vmass-mapping": "Sin vinculación con VMASS",
  "shopee.workspace.catalog.no-vmass-sku": "Sin SKU de VMASS",
  "shopee.workspace.catalog.open-detail-aria": "Abrir detalles",
  "shopee.workspace.catalog.pagination-summary": "Mostrando {from} - {to} de {total} filas de vinculación",
  "shopee.workspace.catalog.detail-sku-label": "SKU VMASS:",
  "shopee.workspace.catalog.detail-item-label": "Artículo de Shopee:",
  "shopee.workspace.catalog.close-detail-aria": "Cerrar detalles",
  "shopee.workspace.catalog.nav-stock": "Stock",
  "shopee.workspace.catalog.nav-history": "Historial",
  "shopee.workspace.catalog.unmapped-badge": "Sin vincular",
  "shopee.workspace.catalog.sku-shopee": "SKU de Shopee",
  "shopee.workspace.catalog.update-mapping": "Actualizar vinculación",
  "shopee.workspace.catalog.map-product-btn": "Vincular producto",
  "shopee.workspace.catalog.no-channel-info": "Aún no hay información del producto",
  "shopee.workspace.catalog.publish-to": "Publicar en {channel}",
  "shopee.workspace.catalog.sync-shopee-catalog": "Sincronizar catálogo de Shopee",
  "shopee.workspace.catalog.unmap": "Desvincular",
  "shopee.workspace.catalog.sku-name-placeholder": "SKU / nombre del producto",
  "shopee.workspace.catalog.draft-created": "Borrador de producto VMASS creado con stock cero",
  "shopee.workspace.catalog.listing-show-queued": "Solicitud de publicación en cola",
  "shopee.workspace.catalog.listing-hide-queued": "Solicitud de ocultar publicación en cola",
  "shopee.workspace.fulfillment.ship-queued": "Solicitud de envío en cola",
  "shopee.workspace.returns.status.requested": "Nueva solicitud",
  "shopee.workspace.returns.status.in-inspection": "En inspección",
  "shopee.workspace.returns.status.waiting-refund": "Esperando reembolso",
  "shopee.workspace.returns.status.processing": "En proceso",
  "shopee.workspace.returns.status.completed": "Completada",
  "shopee.workspace.returns.status.rejected": "Rechazada",
  "shopee.workspace.returns.status.restocked": "Ingresada al stock",
  "shopee.workspace.returns.status.waiting-confirm": "Esperando confirmación",
  "shopee.workspace.returns.inspection-confirmed": "Inspección de devolución confirmada y stock actualizado",
  "shopee.workspace.returns.dispute-queued": "Solicitud de disputa en cola",
  "shopee.workspace.returns.customer-fallback": "Cliente",
  "shopee.workspace.returns.reason-other": "Otro",
  "shopee.workspace.returns.reason-detail-fallback": "Solicitud de devolución",
  "shopee.workspace.returns.item-fallback": "Producto",
  "shopee.workspace.returns.subtitle": "Gestiona todas las solicitudes de devolución, reembolsos y cambios",
  "shopee.workspace.returns.export-excel": "Exportar Excel",
  "shopee.workspace.returns.report": "Informe",
  "shopee.workspace.returns.create-request": "Crear solicitud de devolución",
  "shopee.workspace.returns.kpi-requested-note": "Nuevas y por confirmar",
  "shopee.workspace.returns.kpi-processing-note": "Inspección y procesamiento",
  "shopee.workspace.returns.kpi-waiting-refund-note": "Esperando reembolso",
  "shopee.workspace.returns.kpi-completed-note": "Procesadas por completo",
  "shopee.workspace.returns.kpi-rejected-note": "Solicitudes rechazadas",
  "shopee.workspace.returns.total-refund-today": "Total reembolsado (hoy)",
  "shopee.workspace.returns.return-value-today": "Valor de mercancía devuelta (hoy)",
  "shopee.workspace.returns.pipeline.customer-request": "El cliente solicita devolución",
  "shopee.workspace.returns.pipeline.inspect": "Inspección de mercancía",
  "shopee.workspace.returns.pipeline.approve": "Aprobar devolución",
  "shopee.workspace.returns.pipeline.restock-dispose": "Ingresar al stock / Desechar",
  "shopee.workspace.returns.pipeline.refund": "Reembolso",
  "shopee.workspace.returns.search-placeholder": "Buscar código de devolución, pedido, nombre, teléfono...",
  "shopee.workspace.returns.all-reasons": "Todos los motivos",
  "shopee.workspace.returns.all-warehouses": "Todos los almacenes",
  "shopee.workspace.returns.no-data": "No hay solicitudes de devolución",
  "shopee.workspace.returns.detail-title": "Detalles de la devolución",
  "shopee.workspace.returns.original-order": "Pedido original",
  "shopee.workspace.returns.customer-media": "Fotos/videos del cliente",
  "shopee.workspace.returns.no-media": "El cliente no adjuntó fotos",
  "shopee.workspace.returns.returned-products": "Productos devueltos",
  "shopee.workspace.returns.qty-label": "Cant.",
  "shopee.workspace.returns.inspection-title": "Inspección de mercancía devuelta",
  "shopee.workspace.returns.check.intact": "Productos intactos",
  "shopee.workspace.returns.check.packaging": "Embalaje y etiquetas",
  "shopee.workspace.returns.check.accessories": "Accesorios completos",
  "shopee.workspace.returns.check.correct-product": "Producto correcto",
  "shopee.workspace.returns.check.defect": "Defecto / Daño",
  "shopee.workspace.returns.processing-title": "Procesar devolución",
  "shopee.workspace.returns.action.restock": "Ingresar al stock",
  "shopee.workspace.returns.action.exchange": "Cambiar producto",
  "shopee.workspace.returns.action.discard": "Desechar",
  "shopee.workspace.returns.restock-warehouse": "Almacén de ingreso",
  "shopee.workspace.returns.confirm-continue": "Confirmar y continuar",
  "shopee.workspace.returns.popular-reasons": "Motivos de devolución frecuentes",
  "shopee.workspace.returns.no-reason-data": "Aún no hay datos de motivos",
  "shopee.workspace.returns.top-returned": "Productos más devueltos",
  "shopee.workspace.returns.times-suffix": "veces",
  "shopee.workspace.returns.no-returned-products": "Aún no hay productos devueltos",
  "shopee.workspace.returns.refund-trend": "Valor de reembolso en el tiempo",
  "shopee.workspace.returns.performance": "Rendimiento del procesamiento",
  "shopee.workspace.returns.avg-processing-time": "Tiempo promedio de procesamiento",
  "shopee.workspace.returns.on-time-rate": "Tasa de finalización a tiempo",
  "shopee.workspace.returns.sample-processing-time": "1.8 días",
  "shopee.workspace.returns.sample-processing-delta": "-0.3 días",
  "shopee.workspace.returns.dispute-modal-title": "Abrir disputa en Shopee",
  "shopee.workspace.returns.inspection-modal-title": "Formulario de inspección de devolución",
  "shopee.workspace.returns.condition-placeholder": "Describe el estado real de la mercancía recibida...",
  "shopee.workspace.returns.stock-decision": "Decisión de inventario",
  "shopee.workspace.returns.stock.resellable": "1. Intacto -> Devolver al stock de venta",
  "shopee.workspace.returns.stock.defective": "2. Dañado / Sucio -> Al stock defectuoso",
  "shopee.workspace.returns.stock.discard": "3. Muy dañado / Desechar -> No ingresar al stock",
  "shopee.workspace.returns.stock.shortage": "4. Productos faltantes / Sustituidos -> Informar faltante",
  "shopee.workspace.returns.evidence-placeholder": "Enlaces de fotos/videos como evidencia (URL 1, URL 2)...",
  "shopee.workspace.returns.col.sn": "Código de devolución",
  "shopee.workspace.returns.col.order": "Pedido original",
  "shopee.workspace.returns.col.channel": "Canal",
  "shopee.workspace.returns.col.reason": "Motivo de devolución",
  "shopee.workspace.returns.col.refund-value": "Valor del reembolso",
  "shopee.workspace.returns.col.warehouse": "Almacén",
  "shopee.workspace.returns.col.status": "Estado",
  "shopee.workspace.returns.col.created-at": "Fecha de creación",
  "shopee.workspace.returns.action.inspect": "Inspeccionar e ingresar al stock",
  "shopee.workspace.returns.action.dispute": "Crear disputa en Shopee",
  "shopee.workspace.returns.view-detail-title": "Ver detalles",
  "shopee.workspace.automation.settings-saved": "Configuración de automatización guardada",
  "shopee.workspace.logs.replayed": "Tarea reprocesada",
  "shopee.workspace.common.detail": "Detalles",
  "shopee.workspace.common.page-count": "/ {total} páginas",
  "shopee.workspace.common.no-data": "Aún no hay datos",
  "shopee.workspace.common.close": "Cerrar",
  "shopee.workspace.orders.status.all": "Todas",
  "shopee.workspace.orders.status.unpaid": "Sin pagar",
  "shopee.workspace.orders.status.ready-to-ship": "Pendiente de gestión",
  "shopee.workspace.orders.status.processed": "Procesado",
  "shopee.workspace.orders.status.shipped": "En envío",
  "shopee.workspace.orders.status.to-confirm-receive": "Esperando confirmación de entrega",
  "shopee.workspace.orders.status.completed": "Entregado",
  "shopee.workspace.orders.status.in-cancel": "Cancelando",
  "shopee.workspace.orders.status.cancelled": "Cancelado",
  "shopee.workspace.orders.status-unknown": "Desconocido",
  "shopee.workspace.orders.metric.total": "Pedidos totales",
  "shopee.workspace.orders.metric.total-indicator": "{count} en la página",
  "shopee.workspace.orders.metric.pending": "Pendiente de gestión",
  "shopee.workspace.orders.metric.pending-indicator": "{percent}% de la página",
  "shopee.workspace.orders.metric.deadline": "Fecha límite de envío",
  "shopee.workspace.orders.metric.deadline-overdue": "{count} vencidos",
  "shopee.workspace.orders.metric.deadline-window": "{risk}/{total} con fecha límite",
  "shopee.workspace.orders.metric.deadline-none": "No hay pedidos pendientes de envío",
  "shopee.workspace.orders.metric.gmv": "GMV de pedidos",
  "shopee.workspace.orders.metric.gmv-indicator": "{paid}/{eligible} pedidos con importe",
  "shopee.workspace.orders.metric.delivered": "Entregados",
  "shopee.workspace.orders.tabs-region-aria": "Barra de estados del pedido, desplázate horizontalmente para ver más",
  "shopee.workspace.orders.count-tooltip": "Pedidos en la página actual",
  "shopee.workspace.orders.select-all-aria": "Seleccionar todos los pedidos",
  "shopee.workspace.orders.select-row-aria": "Seleccionar pedido {sn}",
  "shopee.workspace.orders.col.sn": "Código de pedido",
  "shopee.workspace.orders.col.channel": "Canal",
  "shopee.workspace.orders.col.items": "Productos",
  "shopee.workspace.orders.col.amount": "Importe total",
  "shopee.workspace.orders.col.tracking": "Seguimiento",
  "shopee.workspace.orders.col.time": "Hora",
  "shopee.workspace.orders.phone-hidden": "Información oculta",
  "shopee.workspace.orders.items-count": "{count} artículos",
  "shopee.workspace.orders.items-total-x": "Total x{count}",
  "shopee.workspace.orders.paid-time": "Pagado a las {time}",
  "shopee.workspace.orders.paid-time-missing": "Shopee aún no devolvió la hora de pago",
  "shopee.workspace.orders.sync-queued": "Sincronización de pedidos programada",
  "shopee.workspace.orders.sync-button": "Sincronizar pedidos",
  "shopee.workspace.orders.selection-banner": "{count} pedidos seleccionados.",
  "shopee.workspace.orders.export-selected": "Exportar selección",
  "shopee.workspace.orders.clear-selection": "Deseleccionar",
  "shopee.workspace.orders.empty": "No hay pedidos que coincidan.",
  "shopee.workspace.orders.showing-summary": "Mostrando {shown} / {total} pedidos",
  "shopee.workspace.orders.filter-title": "Filtros de búsqueda",
  "shopee.workspace.orders.clear-filters": "Limpiar filtros",
  "shopee.workspace.orders.filter-status-label": "Estado del pedido",
  "shopee.workspace.orders.filter-search-label": "Palabra clave",
  "shopee.workspace.orders.search-placeholder": "Código de pedido o de seguimiento...",
  "shopee.workspace.orders.apply-filters": "Aplicar filtros",
  "shopee.workspace.orders.chart-title": "Distribución de estados en la página",
  "shopee.workspace.orders.detail-title": "Detalles del pedido Shopee #{orderSn}",
  "shopee.workspace.orders.detail-loading": "Cargando detalles del pedido...",
  "shopee.workspace.orders.detail-load-error": "No se pudieron cargar más detalles del pedido.",
  "shopee.workspace.orders.phone-label": "Teléfono:",
  "shopee.workspace.orders.tracking-label": "Código de seguimiento:",
  "shopee.workspace.orders.total-shopee": "Total de Shopee",
  "shopee.workspace.orders.created-at": "Fecha del pedido",
  "shopee.workspace.orders.ship-deadline": "Fecha límite de envío de Shopee",
  "shopee.workspace.orders.items-title": "Lista de productos ({count})",
  "shopee.workspace.orders.price-per-item": "{price} / artículo",
  "shopee.workspace.orders.create-bill": "Crear factura VMASS",
  "shopee.workspace.orders.bill-created": "Factura creada a partir del pedido de Shopee",
  "shopee.workspace.orders.csv.order-code": "Código de pedido",
  "shopee.workspace.orders.csv.phone": "Teléfono",
  "shopee.workspace.orders.csv.products": "Productos",
  "shopee.workspace.orders.csv.amount": "Importe total",
  "shopee.workspace.overview.webhook.configured": "Configurado",
  "shopee.workspace.overview.webhook.processing": "Procesando",
  "shopee.workspace.overview.webhook.degraded": "Necesita revisión",
  "shopee.workspace.overview.webhook.not-configured": "No configurado",
  "shopee.workspace.overview.webhook.unknown": "Desconocido",
  "shopee.workspace.overview.kpi.new-orders": "Pedidos nuevos",
  "shopee.workspace.overview.kpi.new-trend": "Nuevo",
  "shopee.workspace.overview.kpi.new-comparison": "Pedidos nuevos de hoy",
  "shopee.workspace.overview.kpi.pending": "Pendiente / Empaquetado",
  "shopee.workspace.overview.kpi.pending-trend": "Requiere gestión",
  "shopee.workspace.overview.kpi.pending-comparison": "Listos para entregar",
  "shopee.workspace.overview.kpi.expiring": "Entregas cerca de vencer",
  "shopee.workspace.overview.kpi.expiring-priority": "Prioridad",
  "shopee.workspace.overview.kpi.expiring-safe": "Seguro",
  "shopee.workspace.overview.kpi.expiring-comparison": "Gestionar pronto",
  "shopee.workspace.overview.kpi.gmv": "Ingresos de hoy (GMV)",
  "shopee.workspace.overview.kpi.gmv-trend": "GMV total",
  "shopee.workspace.overview.kpi.gmv-comparison": "Ingresos totales",
  "shopee.workspace.overview.kpi.ontime": "Tasa de entrega a tiempo",
  "shopee.workspace.overview.kpi.ontime-trend": "En estándar",
  "shopee.workspace.overview.kpi.ontime-comparison": "Indicador de rendimiento",
  "shopee.workspace.overview.issue.orders": "Pedidos por gestionar",
  "shopee.workspace.overview.issue.orders-desc": "Pedidos que requieren gestión para cumplir el plazo de entrega.",
  "shopee.workspace.overview.issue.mappings": "Vinculaciones por gestionar",
  "shopee.workspace.overview.issue.mappings-desc": "SKUs sin vincular o vinculados incorrectamente.",
  "shopee.workspace.overview.issue.jobs": "Tareas con error",
  "shopee.workspace.overview.issue.jobs-desc": "Tareas de sincronización fallidas que requieren revisión.",
  "shopee.workspace.overview.issue.products": "Productos sin información",
  "shopee.workspace.overview.issue.products-desc": "Productos sin información en algunos canales.",
  "shopee.workspace.overview.issue.reconciliation": "Diferencias de conciliación",
  "shopee.workspace.overview.issue.reconciliation-desc": "Pedidos con diferencias que requieren conciliación.",
  "shopee.workspace.overview.shop-fallback": "Shopee - Tienda {shopId}",
  "shopee.workspace.overview.shop-label": "Tienda {shopId}",
  "shopee.workspace.overview.activity.sync-default": "Sincronización",
  "shopee.workspace.overview.activity.just-now": "Justo ahora",
  "shopee.workspace.overview.activity.success": "Completado",
  "shopee.workspace.overview.activity.attempts": "{count} ejecuciones",
  "shopee.workspace.overview.banner-title": "Resumen de salud y rendimiento del canal Shopee",
  "shopee.workspace.overview.banner-healthy": "Sistema normal",
  "shopee.workspace.overview.banner-attention": "Requiere atención",
  "shopee.workspace.overview.banner-shops-updated": "{count} tiendas conectadas | Actualizado a las: {time}",
  "shopee.workspace.overview.period.today": "Hoy",
  "shopee.workspace.overview.period.week": "7 días",
  "shopee.workspace.overview.period.month": "30 días",
  "shopee.workspace.overview.reload": "Recargar datos",
  "shopee.workspace.overview.mapping-title": "Progreso de vinculación de SKU",
  "shopee.workspace.overview.mapping-tooltip": "Sincronización de stock real entre Shopee y VMASS",
  "shopee.workspace.overview.mapping-percent": "{percent}% Vinculados",
  "shopee.workspace.overview.mapping-progress": "Vinculados {mapped} / {total} SKU de productos",
  "shopee.workspace.overview.mapping-note": "Sincroniza el inventario real automáticamente y evita ventas excesivas con pedidos nuevos.",
  "shopee.workspace.overview.mapping-action": "Vincular SKUs ahora",
  "shopee.workspace.overview.health-title": "Salud de sincronización y conexión Shopee",
  "shopee.workspace.overview.last-sync": "Última sincronización:",
  "shopee.workspace.overview.sparkline-label": "Estado de conexión en tiempo real",
  "shopee.workspace.overview.oauth-label": "Token OAuth:",
  "shopee.workspace.overview.oauth-valid": "Válido",
  "shopee.workspace.overview.oauth-invalid": "Expirado",
  "shopee.workspace.overview.api-label": "Salud API:",
  "shopee.workspace.overview.api-good": "Bien (Normal)",
  "shopee.workspace.overview.api-bad": "Necesita revisión",
  "shopee.workspace.overview.issues-title": "Centro de incidencias",
  "shopee.workspace.overview.manage-connections": "Gestionar conexiones",
  "shopee.workspace.overview.channels-title": "Canales de venta",
  "shopee.workspace.overview.channel-active": "Activo",
  "shopee.workspace.overview.channel-error": "Error de conexión",
  "shopee.workspace.overview.new-orders-colon": "Pedidos nuevos:",
  "shopee.workspace.overview.no-shops": "Aún no hay tiendas conectadas",
  "shopee.workspace.overview.connect-more": "Conectar otro canal de venta",
  "shopee.workspace.overview.view-logs": "Ver registros",
  "shopee.workspace.overview.activity-title": "Actividad de sincronización reciente",
  "shopee.workspace.overview.no-activity": "Aún no hay registros recientes",
  "shopee.workspace.overview.top-products": "Productos más vendidos",
  "shopee.workspace.overview.top-products-note": "por cantidad de pedidos",
  "shopee.workspace.overview.top-period": "Estadísticas de los últimos 7 días",
  "shopee.workspace.overview.product-unknown": "Producto sin identificar",
  "shopee.workspace.overview.sold-count": "{count} pedidos",
  "shopee.workspace.overview.no-products": "Aún no hay datos de productos",
  "shopee.workspace.overview.revenue-title": "Ingresos por canal",
  "shopee.workspace.overview.revenue-period": "Ingresos de los últimos 7 días",
  "shopee.workspace.overview.revenue-total-aria": "Ingresos totales {amount}",
  "shopee.workspace.overview.total-revenue": "Ingresos totales",
  "shopee.workspace.error.no-response": "La solicitud a Shopee no respondió. Comprueba Redis y el worker de Shopee e inténtalo de nuevo.",
  "shopee.workspace.error.load-failed": "No se pudieron cargar los datos de Shopee",
  "shopee.workspace.notice.job-completed": "Tarea de Shopee completada",
  "shopee.workspace.notice.job-ended-status": "La tarea de Shopee terminó con estado {status}",
  "shopee.workspace.notice.job-status-updated": "Tarea {status}",
  "shopee.workspace.notice.job-status-default": "actualizada",
  "shopee.workspace.notice.new-order": "Nuevo pedido recibido de Shopee",
  "shopee.workspace.notice.action-queued": "Tarea en cola correctamente",
  "shopee.workspace.notice.action-success": "Actualizado correctamente",
  "shopee.workspace.common.back": "Atrás",
  "shopee.workspace.common.next-step": "Siguiente",
  "shopee.workspace.connections.title": "Canales de venta y tiendas conectadas",
  "shopee.workspace.connections.subtitle": "Gestiona la autorización OAuth, las políticas de sincronización y las conexiones de tiendas Shopee",
  "shopee.workspace.connections.add-shop-wizard": "Añadir una nueva tienda de Shopee (asistente de 6 pasos)",
  "shopee.workspace.connections.status-active": "ACTIVA",
  "shopee.workspace.connections.region-id": "Región: {region} | ID de tienda: {shopId}",
  "shopee.workspace.connections.scopes-label": "Permisos autorizados:",
  "shopee.workspace.connections.scope.orders": "Pedidos",
  "shopee.workspace.connections.scope.catalog": "Catálogo",
  "shopee.workspace.connections.scope.stock": "Stock",
  "shopee.workspace.connections.scope.finance": "Finanzas",
  "shopee.workspace.connections.scope.return": "Devoluciones",
  "shopee.workspace.connections.last-sync-colon": "Última sincronización:",
  "shopee.workspace.connections.reauth-title": "Reautorizar",
  "shopee.workspace.connections.reauth": "Repetir OAuth",
  "shopee.workspace.connections.disconnect-title": "Desconectar",
  "shopee.workspace.connections.disconnected-notice": "Tienda {shop} desconectada",
  "shopee.workspace.connections.disconnect-btn": "Quitar",
  "shopee.workspace.connections.empty": "Aún no hay tiendas de Shopee conectadas.",
  "shopee.workspace.connections.connect-new": "+ Conectar una nueva tienda de Shopee",
  "shopee.workspace.connections.wizard.title": "Asistente de conexión y activación de tienda Shopee (paso {step}/6)",
  "shopee.workspace.connections.wizard.step1-title": "Paso 1: Conectar y autorizar OAuth con Shopee",
  "shopee.workspace.connections.wizard.step1-desc": "Serás redirigido al portal oficial de autorización de Shopee Partner Platform para iniciar sesión en tu tienda.",
  "shopee.workspace.connections.wizard.step1-permissions": "El acceso incluye:",
  "shopee.workspace.connections.wizard.step1-permissions-detail": "Lectura/escritura de pedidos, sincronización de catálogo, actualización de stock e historial de liquidaciones.",
  "shopee.workspace.connections.wizard.open-oauth": "Ir a la página de inicio de sesión y autorización de Shopee",
  "shopee.workspace.connections.wizard.step2-title": "Paso 2: Elige la importación inicial de datos",
  "shopee.workspace.connections.wizard.step2-desc": "Elige qué tipos de datos importar de Shopee a VMASS:",
  "shopee.workspace.connections.wizard.step2-products": "Todos los productos y variantes de Shopee",
  "shopee.workspace.connections.wizard.step2-orders": "Pedidos de los últimos 30 días",
  "shopee.workspace.connections.wizard.step2-logistics": "Dirección de recogida y transportistas",
  "shopee.workspace.connections.wizard.step3-title": "Paso 3: Define la fuente de verdad",
  "shopee.workspace.connections.wizard.step3-desc": "La fuente de verdad decide qué sistema gestiona la cantidad maestra de stock:",
  "shopee.workspace.connections.wizard.step3-vmass-strong": "VMASS como fuente de verdad (recomendado):",
  "shopee.workspace.connections.wizard.step3-vmass-desc": "El stock de VMASS se envía automáticamente a Shopee tras procesar los pedidos.",
  "shopee.workspace.connections.wizard.step3-shopee-strong": "Shopee como fuente inicial:",
  "shopee.workspace.connections.wizard.step3-shopee-desc": "Usa la cantidad actual de stock en Shopee como referencia para la primera sincronización.",
  "shopee.workspace.connections.wizard.step4-title": "Paso 4: Revisar la vinculación de SKU",
  "shopee.workspace.connections.wizard.step4-info": "El 85% de los SKU de Shopee coincide exactamente con los SKU del almacén VMASS. Estos SKU se vincularán automáticamente.",
  "shopee.workspace.connections.wizard.step4-note": "Los SKU sin vincular se pueden gestionar en la pestaña \"Vinculación de productos\" tras la activación.",
  "shopee.workspace.connections.wizard.step5-title": "Paso 5: Configurar la política de stock y precios",
  "shopee.workspace.connections.wizard.allocation-label": "Modo de asignación de stock",
  "shopee.workspace.connections.wizard.option-shared": "SHARED (compartir el 100% del stock vendible)",
  "shopee.workspace.connections.wizard.option-allocated": "ALLOCATED (reservar una cuota fija)",
  "shopee.workspace.connections.wizard.option-percentage": "PERCENTAGE (reparto por porcentaje)",
  "shopee.workspace.connections.wizard.safety-buffer-label": "Stock de seguridad",
  "shopee.workspace.connections.wizard.safety-buffer-hint": "Evita ventas excesivas al vender en varios canales.",
  "shopee.workspace.connections.wizard.step6-title": "Paso 6: Verificar y activar la tienda",
  "shopee.workspace.connections.wizard.step6-ready-strong": "¡Listo para activar!",
  "shopee.workspace.connections.wizard.step6-ready-detail": "Todas las configuraciones son válidas y sin conflictos graves.",
  "shopee.workspace.connections.wizard.check-oauth": "✔ Autorizado con Shopee Partner API v2",
  "shopee.workspace.connections.wizard.check-sot": "✔ Fuente de verdad: {value}",
  "shopee.workspace.connections.wizard.check-stock-mode": "✔ Modo de stock: {mode} (Stock de seguridad: {buffer})",
  "shopee.workspace.connections.wizard.opening-shopee": "Abriendo el portal de Shopee...",
  "shopee.workspace.connections.wizard.connect-now": "Conectar OAuth de Shopee ahora",
  "shopee.workspace.connections.wizard.activate-done": "Nueva tienda de Shopee activada correctamente",
  "shopee.workspace.connections.wizard.activate-now": "Activar tienda ahora",
  "shopee.workspace.inventory.status.unknown": "Datos insuficientes",
  "shopee.workspace.inventory.status.unmapped": "Sin vincular en VMASS",
  "shopee.workspace.inventory.status.error": "Error de sincronización",
  "shopee.workspace.inventory.status.out-of-stock": "Agotado en Shopee",
  "shopee.workspace.inventory.status.variance": "Diferencia",
  "shopee.workspace.inventory.status.synced": "Sincronizado",
  "shopee.workspace.inventory.no-name": "Shopee no proporciona nombre del producto",
  "shopee.workspace.inventory.sub.on-page": "En la página actual",
  "shopee.workspace.inventory.sub.by-filter": "Según el filtro actual",
  "shopee.workspace.inventory.sub.from-loaded-mappings": "Según los datos de vinculación cargados",
  "shopee.workspace.inventory.kpi.total": "Total de vinculaciones Shopee",
  "shopee.workspace.inventory.kpi.synced-sub": "De {count} filas cargadas",
  "shopee.workspace.inventory.kpi.variance": "Diferencia de stock",
  "shopee.workspace.inventory.kpi.errors-sub": "{count} errores de sincronización",
  "shopee.workspace.inventory.kpi.last-sync": "Última actualización",
  "shopee.workspace.inventory.col.vmass-stock": "Stock VMASS",
  "shopee.workspace.inventory.col.total": "Total",
  "shopee.workspace.inventory.col.diff-formula": "Shopee - VMASS",
  "shopee.workspace.inventory.col.condition": "Estado",
  "shopee.workspace.inventory.col.updated": "Actualizado",
  "shopee.workspace.inventory.col.last": "Última",
  "shopee.workspace.inventory.img-placeholder-aria": "Sin imagen del producto",
  "shopee.workspace.inventory.title": "Stock de Shopee",
  "shopee.workspace.inventory.subtitle": "Compara el stock vendible de VMASS con el catálogo de Shopee sincronizado.",
  "shopee.workspace.inventory.manage-mapping": "Gestionar vinculación de productos",
  "shopee.workspace.inventory.search-placeholder": "Buscar productos o SKU de Shopee...",
  "shopee.workspace.inventory.filter.all": "Todos los estados",
  "shopee.workspace.inventory.shop-colon": "Tienda:",
  "shopee.workspace.inventory.no-shop-selected": "Ninguna tienda seleccionada",
  "shopee.workspace.inventory.loading": "Cargando datos de Shopee...",
  "shopee.workspace.inventory.empty": "Ninguna vinculación de Shopee coincide con el filtro.",
  "shopee.workspace.inventory.pagination-summary": "Mostrando {from} - {to} de {total} vinculaciones de Shopee",
  "shopee.workspace.inventory.side.overview-title": "Resumen de stock",
  "shopee.workspace.inventory.legend.filtered": "Vinculaciones por filtro",
  "shopee.workspace.inventory.legend.synced-page": "Sincronizadas en la página",
  "shopee.workspace.inventory.legend.variance-page": "Con diferencia en la página",
  "shopee.workspace.inventory.side.top-variance": "Mayores diferencias de stock",
  "shopee.workspace.inventory.side.no-variance": "No hay diferencias de stock en los datos cargados.",
  "shopee.workspace.inventory.side.alerts-title": "Alertas de stock",
  "shopee.workspace.inventory.alert.out-of-stock": "{count} productos agotados en Shopee",
  "shopee.workspace.inventory.alert.variance": "{count} productos con diferencia de stock",
  "shopee.workspace.inventory.alert.variance-desc": "Shopee difiere de VMASS",
  "shopee.workspace.inventory.alert.unmapped": "{count} productos sin vincular en VMASS",
  "shopee.workspace.inventory.alert.unmapped-desc": "Vincule los productos antes de comparar",
  "shopee.workspace.pricing.kpi.total": "Total de SKU",
  "shopee.workspace.pricing.kpi.synced": "Precios sincronizados",
  "shopee.workspace.pricing.kpi.variance": "Diferencia de precio",
  "shopee.workspace.pricing.kpi.pending": "Sin actualizar",
  "shopee.workspace.pricing.kpi.pending-sub": "Falta precio de Shopee o VMASS",
  "shopee.workspace.pricing.kpi.errors": "Errores de precio",
  "shopee.workspace.pricing.subtitle": "Gestione y sincronice precios de productos entre VMASS y los canales de venta",
  "shopee.workspace.pricing.search-placeholder": "Buscar nombre, SKU, código de barras...",
  "shopee.workspace.pricing.category.all": "Todas las categorías",
  "shopee.workspace.pricing.category.fashion": "Moda",
  "shopee.workspace.pricing.category.electronics": "Electrónica",
  "shopee.workspace.pricing.category.food": "Alimentos",
  "shopee.workspace.pricing.warehouse.main": "Almacén principal",
  "shopee.workspace.pricing.warehouse.hanoi": "Almacén de Hanói",
  "shopee.workspace.pricing.warehouse.hcm": "Almacén de HCMC",
  "shopee.workspace.pricing.pagination-summary": "Mostrando {from} - {to} de {total} productos de Shopee",
  "shopee.workspace.pricing.col.vmass-price": "Precio VMASS",
  "shopee.workspace.pricing.col.price-small": "Precio de venta",
  "shopee.workspace.pricing.col.diff-range": "Más alto - Más bajo",
  "shopee.workspace.pricing.action.adjust-price": "Ajustar precio",
  "shopee.workspace.pricing.action.sync-price-list": "Sincronizar lista de precios",
  "shopee.workspace.pricing.action.cancel-rule": "Cancelar regla de precio",
  "shopee.workspace.pricing.action.sync-price": "Sincronizar precios",
  "shopee.workspace.pricing.action.batch-update": "Actualización masiva",
  "shopee.workspace.pricing.action.price-rules": "Reglas de precio",
  "shopee.workspace.pricing.alert.higher": "{count} productos con precio más alto",
  "shopee.workspace.pricing.alert.lower": "{count} productos con precio más bajo",
  "shopee.workspace.pricing.alert.unavailable": "{count} productos sin datos de precio",
  "shopee.workspace.pricing.alert.threshold-desc": "frente a VMASS > 10%",
  "shopee.workspace.pricing.sub.on-page-short": "En página",
  "shopee.workspace.pricing.side.variance-title": "Resumen de diferencias de precio",
  "shopee.workspace.pricing.side.top-variance": "Mayores diferencias de precio",
  "shopee.workspace.pricing.side.no-variance": "No hay diferencias de precio en los datos de Shopee cargados.",
  "shopee.workspace.pricing.side.alerts-title": "Alertas de precio",
  "shopee.workspace.pricing.rule.title": "Configurador de política de precios por canal",
  "shopee.workspace.pricing.rule.policy-mode": "Modo de política",
  "shopee.workspace.pricing.rule.option-direct": "Usar precio VMASS directamente",
  "shopee.workspace.pricing.rule.option-percent": "Recargo porcentual",
  "shopee.workspace.pricing.rule.option-fixed": "Recargo de monto fijo",
  "shopee.workspace.pricing.rule.option-cost-plus": "Costo más gastos y margen",
  "shopee.workspace.pricing.rule.markup-percent-label": "Porcentaje de recargo (%)",
  "shopee.workspace.pricing.rule.markup-amount-label": "Monto fijo de recargo (VND)",
  "shopee.workspace.pricing.rule.fee-label": "Comisión estimada del canal (%)",
  "shopee.workspace.pricing.rule.packaging-label": "Costo de embalaje (VND)",
  "shopee.workspace.pricing.rule.rounding-label": "Regla de redondeo",
  "shopee.workspace.pricing.rule.rounding-none": "Sin redondeo",
  "shopee.workspace.pricing.rule.rounding-thousand": "Redondear a millar (.000)",
  "shopee.workspace.pricing.rule.rounding-nine-thousand": "Terminación en 9.000 (.9.000)",
  "shopee.workspace.pricing.rule.formula-strong": "Fórmula aplicada:",
  "shopee.workspace.pricing.rule.formula-text": "Precio del canal = [Precio VMASS + tarifa fija] / (1 - % comisión del canal) -> redondeo.",
  "shopee.workspace.pricing.rule.preview-no-base": "No hay precio VMASS en los datos de Shopee cargados para la vista previa.",
  "shopee.workspace.pricing.rule.preview-from": "Vista previa desde el precio VMASS {base}: {result}",
  "shopee.workspace.pricing.rule.save-preview": "Guardar regla y vista previa",
  "shopee.workspace.pricing.approve.title": "Confirmar aprobación y envío de la lista de precios masiva a Shopee",
  "shopee.workspace.pricing.approve.warning-strong": "Advertencia de seguridad:",
  "shopee.workspace.pricing.approve.warning-detail": "Esta acción aplicará la nueva regla de precio y sincronizará la lista de precios con Shopee.",
  "shopee.workspace.pricing.approve.items-total": "Total de artículos",
  "shopee.workspace.pricing.approve.rule-applied": "Regla aplicada",
  "shopee.workspace.pricing.approve.fee-deducted": "Comisión del canal deducida",
  "shopee.workspace.pricing.approve.queued": "Tarea de actualización masiva de precios iniciada para Shopee",
  "shopee.workspace.pricing.approve.confirm": "Aprobar y actualizar precios",
  "shopee.workspace.mapping.model-simple": "Producto simple",
  "shopee.workspace.mapping.draft-created-from-listing": "Producto VMASS creado a partir de la publicación de Shopee",
  "shopee.workspace.mapping.no-provider-data": "Shopee no proporciona datos",
  "shopee.workspace.mapping.tooltip-full": "SKU {sku} · Precio {price} · Stock {stock}",
  "shopee.workspace.mapping.tooltip-price-stock": "Precio {price} · Stock {stock}",
  "shopee.workspace.mapping.stock-colon": "Stock:",
  "shopee.workspace.mapping.price-label": "Precio",
  "shopee.workspace.mapping.col.vmass-product": "Producto en VMASS",
  "shopee.workspace.mapping.col.mapping": "Vinculación",
  "shopee.workspace.mapping.pick-product-aria": "Elegir un producto VMASS para vincular",
  "shopee.workspace.mapping.no-mapping-permission": "No tiene permiso para vincular productos",
  "shopee.workspace.common.pick-product": "Elegir producto",
  "shopee.workspace.common.retry": "Reintentar",
  "shopee.workspace.common.yes": "Sí",
  "shopee.workspace.common.no": "No",
  "shopee.workspace.mapping.state-conflict": "Conflicto",
  "shopee.workspace.mapping.auto-map-launched": "Auto-vinculación iniciada para {count} vinculaciones de Shopee",
  "shopee.workspace.mapping.inventory-sync-queued": "Sincronización de inventario del producto Shopee programada",
  "shopee.workspace.mapping.no-shop-selected": "Ninguna tienda de Shopee seleccionada. Conecte o seleccione una tienda para cargar datos reales de vinculación.",
  "shopee.workspace.mapping.kpi.total-sub": "{count} filas de vinculación desde la API",
  "shopee.workspace.mapping.kpi.rate-page": "{percent}% en la página actual",
  "shopee.workspace.mapping.kpi.rate": "Tasa de vinculación",
  "shopee.workspace.mapping.search-placeholder": "Buscar SKU, código de barras, nombre...",
  "shopee.workspace.mapping.title": "Vinculaciones de Shopee",
  "shopee.workspace.mapping.data-scope-banner": "Datos de la tienda {shop}; las métricas de estado se calculan en la página actual.",
  "shopee.workspace.mapping.shop-unselected": "sin seleccionar",
  "shopee.workspace.mapping.loading": "Cargando vinculaciones desde Shopee...",
  "shopee.workspace.mapping.empty": "Shopee no devolvió vinculaciones que coincidan con la tienda y el filtro actual.",
  "shopee.workspace.mapping.detail-title": "Detalles de la vinculación",
  "shopee.workspace.mapping.tab-info": "Información",
  "shopee.workspace.mapping.tab-history": "Historial",
  "shopee.workspace.mapping.status.disabled": "Sincronización desactivada",
  "shopee.workspace.mapping.status.error": "Error de sincronización",
  "shopee.workspace.mapping.status.healthy": "Saludable",
  "shopee.workspace.mapping.status.mapping-required": "Sin vincular",
  "shopee.workspace.mapping.status.out-of-stock": "Agotado",
  "shopee.workspace.mapping.section-vmass": "Información de VMASS",
  "shopee.workspace.mapping.section-shopee": "Datos de Shopee",
  "shopee.workspace.mapping.available-stock": "Stock disponible",
  "shopee.workspace.mapping.shopee-name-colon": "Nombre en Shopee:",
  "shopee.workspace.mapping.not-linked": "Sin vincular al canal Shopee",
  "shopee.workspace.mapping.sync-enabled-colon": "Sincronización permitida:",
  "shopee.workspace.mapping.auto-map-this": "Auto-vincular este SKU",
  "shopee.workspace.mapping.change": "Cambiar vinculación",
  "shopee.workspace.mapping.remove": "Quitar vinculación",
  "shopee.workspace.mapping.history-created": "Vinculación creada:",
  "shopee.workspace.mapping.history-updated": "Vinculación actualizada:",
  "shopee.workspace.mapping.history-last-sync": "Última sincronización con Shopee:",
  "shopee.workspace.mapping.sync-stock-to-shopee": "Sincronizar stock con Shopee",
  "shopee.workspace.mapping.modal-title": "Elegir un producto VMASS para vincular",
  "shopee.workspace.mapping.candidate-search-placeholder": "Buscar por nombre, SKU o código de barras de VMASS",
  "shopee.workspace.mapping.candidates-loading": "Cargando productos VMASS...",
  "shopee.workspace.mapping.choose-product": "Elegir producto VMASS",
  "shopee.workspace.mapping.nameless-product": "Producto sin nombre",
"shopee.workspace.connections.wizard.step1-title": "Paso 1: Conectar y autorizar OAuth con Shopee",
  "shopee.workspace.connections.wizard.step1-desc": "Serás redirigido al portal oficial de autorización de Shopee Partner Platform para iniciar sesión en tu tienda.",
  "shopee.workspace.connections.wizard.step1-permissions": "El acceso incluye:",
  "shopee.workspace.connections.wizard.step1-permissions-detail": "Lectura/escritura de pedidos, sincronización de catálogo, actualización de stock e historial de liquidaciones.",
  "shopee.workspace.connections.wizard.open-oauth": "Ir a la página de inicio de sesión y autorización de Shopee",
  "shopee.workspace.connections.wizard.step2-title": "Paso 2: Elige la importación inicial de datos",
  "shopee.workspace.connections.wizard.step2-desc": "Elige qué tipos de datos importar de Shopee a VMASS:",
  "shopee.workspace.connections.wizard.step2-products": "Todos los productos y variantes de Shopee",
  "shopee.workspace.connections.wizard.step2-orders": "Pedidos de los últimos 30 días",
  "shopee.workspace.connections.wizard.step2-logistics": "Dirección de recogida y transportistas",
  "shopee.workspace.connections.wizard.step3-title": "Paso 3: Define la fuente de verdad",
  "shopee.workspace.connections.wizard.step3-desc": "La fuente de verdad decide qué sistema gestiona la cantidad maestra de stock:",
  "shopee.workspace.connections.wizard.step3-vmass-strong": "VMASS como fuente de verdad (recomendado):",
  "shopee.workspace.connections.wizard.step3-vmass-desc": "El stock de VMASS se envía automáticamente a Shopee tras procesar los pedidos.",
  "shopee.workspace.connections.wizard.step3-shopee-strong": "Shopee como fuente inicial:",
  "shopee.workspace.connections.wizard.step3-shopee-desc": "Usa la cantidad actual de stock en Shopee como referencia para la primera sincronización.",
  "shopee.workspace.connections.wizard.step4-title": "Paso 4: Revisar la vinculación de SKU",
  "shopee.workspace.connections.wizard.step4-info": "El 85% de los SKU de Shopee coincide exactamente con los SKU del almacén VMASS. Estos SKU se vincularán automáticamente.",
  "shopee.workspace.connections.wizard.step4-note": "Los SKU sin vincular se pueden gestionar en la pestaña \"Vinculación de productos\" tras la activación.",
  "shopee.workspace.connections.wizard.step5-title": "Paso 5: Configurar la política de stock y precios",
  "shopee.workspace.connections.wizard.allocation-label": "Modo de asignación de stock",
  "shopee.workspace.connections.wizard.option-shared": "SHARED (compartir el 100% del stock vendible)",
  "shopee.workspace.connections.wizard.option-allocated": "ALLOCATED (reservar una cuota fija)",
  "shopee.workspace.connections.wizard.option-percentage": "PERCENTAGE (reparto por porcentaje)",
  "shopee.workspace.connections.wizard.safety-buffer-label": "Stock de seguridad",
  "shopee.workspace.connections.wizard.safety-buffer-hint": "Evita ventas excesivas al vender en varios canales.",
  "shopee.workspace.connections.wizard.step6-title": "Paso 6: Verificar y activar la tienda",
  "shopee.workspace.connections.wizard.step6-ready-strong": "¡Listo para activar!",
  "shopee.workspace.connections.wizard.step6-ready-detail": "Todas las configuraciones son válidas y sin conflictos graves.",
  "shopee.workspace.connections.wizard.check-oauth": "✔ Autorizado con Shopee Partner API v2",
  "shopee.workspace.connections.wizard.check-sot": "✔ Fuente de verdad: {value}",
  "shopee.workspace.connections.wizard.check-stock-mode": "✔ Modo de stock: {mode} (Stock de seguridad: {buffer})",
  "shopee.workspace.connections.wizard.opening-shopee": "Abriendo el portal de Shopee...",
  "shopee.workspace.connections.wizard.connect-now": "Conectar OAuth de Shopee ahora",
  "shopee.workspace.connections.wizard.activate-done": "Nueva tienda de Shopee activada correctamente",
  "shopee.workspace.connections.wizard.activate-now": "Activar tienda ahora",
  "shopee.workspace.inventory.status.unknown": "Datos insuficientes",
  "shopee.workspace.inventory.status.unmapped": "Sin vincular en VMASS",
  "shopee.workspace.inventory.status.error": "Error de sincronización",
  "shopee.workspace.inventory.status.out-of-stock": "Agotado en Shopee",
  "shopee.workspace.inventory.status.variance": "Diferencia",
  "shopee.workspace.inventory.status.synced": "Sincronizado",
  "shopee.workspace.inventory.no-name": "Shopee no proporciona nombre del producto",
  "shopee.workspace.inventory.sub.on-page": "En la página actual",
  "shopee.workspace.inventory.sub.by-filter": "Según el filtro actual",
  "shopee.workspace.inventory.sub.from-loaded-mappings": "Según los datos de vinculación cargados",
  "shopee.workspace.inventory.kpi.total": "Total de vinculaciones Shopee",
  "shopee.workspace.inventory.kpi.synced-sub": "De {count} filas cargadas",
  "shopee.workspace.inventory.kpi.variance": "Diferencia de stock",
  "shopee.workspace.inventory.kpi.errors-sub": "{count} errores de sincronización",
  "shopee.workspace.inventory.kpi.last-sync": "Última actualización",
  "shopee.workspace.inventory.col.vmass-stock": "Stock VMASS",
  "shopee.workspace.inventory.col.total": "Total",
  "shopee.workspace.inventory.col.diff-formula": "Shopee - VMASS",
  "shopee.workspace.inventory.col.condition": "Estado",
  "shopee.workspace.inventory.col.updated": "Actualizado",
  "shopee.workspace.inventory.col.last": "Última",
  "shopee.workspace.inventory.img-placeholder-aria": "Sin imagen del producto",
  "shopee.workspace.inventory.title": "Stock de Shopee",
  "shopee.workspace.inventory.subtitle": "Compara el stock vendible de VMASS con el catálogo de Shopee sincronizado.",
  "shopee.workspace.inventory.manage-mapping": "Gestionar vinculación de productos",
  "shopee.workspace.inventory.search-placeholder": "Buscar productos o SKU de Shopee...",
  "shopee.workspace.inventory.filter.all": "Todos los estados",
  "shopee.workspace.inventory.shop-colon": "Tienda:",
  "shopee.workspace.inventory.no-shop-selected": "Ninguna tienda seleccionada",
  "shopee.workspace.inventory.loading": "Cargando datos de Shopee...",
  "shopee.workspace.inventory.empty": "Ninguna vinculación de Shopee coincide con el filtro.",
  "shopee.workspace.inventory.pagination-summary": "Mostrando {from} - {to} de {total} vinculaciones de Shopee",
  "shopee.workspace.inventory.side.overview-title": "Resumen de stock",
  "shopee.workspace.inventory.legend.filtered": "Vinculaciones por filtro",
  "shopee.workspace.inventory.legend.synced-page": "Sincronizadas en la página",
  "shopee.workspace.inventory.legend.variance-page": "Con diferencia en la página",
  "shopee.workspace.inventory.side.top-variance": "Mayores diferencias de stock",
  "shopee.workspace.inventory.side.no-variance": "No hay diferencias de stock en los datos cargados.",
  "shopee.workspace.inventory.side.alerts-title": "Alertas de stock",
  "shopee.workspace.inventory.alert.out-of-stock": "{count} productos agotados en Shopee",
  "shopee.workspace.inventory.alert.variance": "{count} productos con diferencia de stock",
  "shopee.workspace.inventory.alert.variance-desc": "Shopee difiere de VMASS",
  "shopee.workspace.inventory.alert.unmapped": "{count} productos sin vincular en VMASS",
  "shopee.workspace.inventory.alert.unmapped-desc": "Vincule los productos antes de comparar",
  "shopee.workspace.pricing.kpi.total": "Total de SKU",
  "shopee.workspace.pricing.kpi.synced": "Precios sincronizados",
  "shopee.workspace.pricing.kpi.variance": "Diferencia de precio",
  "shopee.workspace.pricing.kpi.pending": "Sin actualizar",
  "shopee.workspace.pricing.kpi.pending-sub": "Falta precio de Shopee o VMASS",
  "shopee.workspace.pricing.kpi.errors": "Errores de precio",
  "shopee.workspace.pricing.subtitle": "Gestione y sincronice precios de productos entre VMASS y los canales de venta",
  "shopee.workspace.pricing.search-placeholder": "Buscar nombre, SKU, código de barras...",
  "shopee.workspace.pricing.category.all": "Todas las categorías",
  "shopee.workspace.pricing.category.fashion": "Moda",
  "shopee.workspace.pricing.category.electronics": "Electrónica",
  "shopee.workspace.pricing.category.food": "Alimentos",
  "shopee.workspace.pricing.warehouse.main": "Almacén principal",
  "shopee.workspace.pricing.warehouse.hanoi": "Almacén de Hanói",
  "shopee.workspace.pricing.warehouse.hcm": "Almacén de HCMC",
  "shopee.workspace.pricing.pagination-summary": "Mostrando {from} - {to} de {total} productos de Shopee",
  "shopee.workspace.pricing.col.vmass-price": "Precio VMASS",
  "shopee.workspace.pricing.col.price-small": "Precio de venta",
  "shopee.workspace.pricing.col.diff-range": "Más alto - Más bajo",
  "shopee.workspace.pricing.action.adjust-price": "Ajustar precio",
  "shopee.workspace.pricing.action.sync-price-list": "Sincronizar lista de precios",
  "shopee.workspace.pricing.action.cancel-rule": "Cancelar regla de precio",
  "shopee.workspace.pricing.action.sync-price": "Sincronizar precios",
  "shopee.workspace.pricing.action.batch-update": "Actualización masiva",
  "shopee.workspace.pricing.action.price-rules": "Reglas de precio",
  "shopee.workspace.pricing.alert.higher": "{count} productos con precio más alto",
  "shopee.workspace.pricing.alert.lower": "{count} productos con precio más bajo",
  "shopee.workspace.pricing.alert.unavailable": "{count} productos sin datos de precio",
  "shopee.workspace.pricing.alert.threshold-desc": "frente a VMASS > 10%",
  "shopee.workspace.pricing.sub.on-page-short": "En página",
  "shopee.workspace.pricing.side.variance-title": "Resumen de diferencias de precio",
  "shopee.workspace.pricing.side.top-variance": "Mayores diferencias de precio",
  "shopee.workspace.pricing.side.no-variance": "No hay diferencias de precio en los datos de Shopee cargados.",
  "shopee.workspace.pricing.side.alerts-title": "Alertas de precio",
  "shopee.workspace.pricing.rule.title": "Configurador de política de precios por canal",
  "shopee.workspace.pricing.rule.policy-mode": "Modo de política",
  "shopee.workspace.pricing.rule.option-direct": "Usar precio VMASS directamente",
  "shopee.workspace.pricing.rule.option-percent": "Recargo porcentual",
  "shopee.workspace.pricing.rule.option-fixed": "Recargo de monto fijo",
  "shopee.workspace.pricing.rule.option-cost-plus": "Costo más gastos y margen",
  "shopee.workspace.pricing.rule.markup-percent-label": "Porcentaje de recargo (%)",
  "shopee.workspace.pricing.rule.markup-amount-label": "Monto fijo de recargo (VND)",
  "shopee.workspace.pricing.rule.fee-label": "Comisión estimada del canal (%)",
  "shopee.workspace.pricing.rule.packaging-label": "Costo de embalaje (VND)",
  "shopee.workspace.pricing.rule.rounding-label": "Regla de redondeo",
  "shopee.workspace.pricing.rule.rounding-none": "Sin redondeo",
  "shopee.workspace.pricing.rule.rounding-thousand": "Redondear a millar (.000)",
  "shopee.workspace.pricing.rule.rounding-nine-thousand": "Terminación en 9.000 (.9.000)",
  "shopee.workspace.pricing.rule.formula-strong": "Fórmula aplicada:",
  "shopee.workspace.pricing.rule.formula-text": "Precio del canal = [Precio VMASS + tarifa fija] / (1 - % comisión del canal) -> redondeo.",
  "shopee.workspace.pricing.rule.preview-no-base": "No hay precio VMASS en los datos de Shopee cargados para la vista previa.",
  "shopee.workspace.pricing.rule.preview-from": "Vista previa desde el precio VMASS {base}: {result}",
  "shopee.workspace.pricing.rule.save-preview": "Guardar regla y vista previa",
  "shopee.workspace.pricing.approve.title": "Confirmar aprobación y envío de la lista de precios masiva a Shopee",
  "shopee.workspace.pricing.approve.warning-strong": "Advertencia de seguridad:",
  "shopee.workspace.pricing.approve.warning-detail": "Esta acción aplicará la nueva regla de precio y sincronizará la lista de precios con Shopee.",
  "shopee.workspace.pricing.approve.items-total": "Total de artículos",
  "shopee.workspace.pricing.approve.rule-applied": "Regla aplicada",
  "shopee.workspace.pricing.approve.fee-deducted": "Comisión del canal deducida",
  "shopee.workspace.pricing.approve.queued": "Tarea de actualización masiva de precios iniciada para Shopee",
  "shopee.workspace.pricing.approve.confirm": "Aprobar y actualizar precios",
  "shopee.workspace.mapping.model-simple": "Producto simple",
  "shopee.workspace.mapping.draft-created-from-listing": "Producto VMASS creado a partir de la publicación de Shopee",
  "shopee.workspace.mapping.no-provider-data": "Shopee no proporciona datos",
  "shopee.workspace.mapping.tooltip-full": "SKU {sku} · Precio {price} · Stock {stock}",
  "shopee.workspace.mapping.tooltip-price-stock": "Precio {price} · Stock {stock}",
  "shopee.workspace.mapping.stock-colon": "Stock:",
  "shopee.workspace.mapping.price-label": "Precio",
  "shopee.workspace.mapping.col.vmass-product": "Producto en VMASS",
  "shopee.workspace.mapping.col.mapping": "Vinculación",
  "shopee.workspace.mapping.pick-product-aria": "Elegir un producto VMASS para vincular",
  "shopee.workspace.mapping.no-mapping-permission": "No tiene permiso para vincular productos",
  "shopee.workspace.common.pick-product": "Elegir producto",
  "shopee.workspace.common.retry": "Reintentar",
  "shopee.workspace.common.yes": "Sí",
  "shopee.workspace.common.no": "No",
  "shopee.workspace.mapping.state-conflict": "Conflicto",
  "shopee.workspace.mapping.auto-map-launched": "Auto-vinculación iniciada para {count} vinculaciones de Shopee",
  "shopee.workspace.mapping.inventory-sync-queued": "Sincronización de inventario del producto Shopee programada",
  "shopee.workspace.mapping.no-shop-selected": "Ninguna tienda de Shopee seleccionada. Conecte o seleccione una tienda para cargar datos reales de vinculación.",
  "shopee.workspace.mapping.kpi.total-sub": "{count} filas de vinculación desde la API",
  "shopee.workspace.mapping.kpi.rate-page": "{percent}% en la página actual",
  "shopee.workspace.mapping.kpi.rate": "Tasa de vinculación",
  "shopee.workspace.mapping.search-placeholder": "Buscar SKU, código de barras, nombre...",
  "shopee.workspace.mapping.title": "Vinculaciones de Shopee",
  "shopee.workspace.mapping.data-scope-banner": "Datos de la tienda {shop}; las métricas de estado se calculan en la página actual.",
  "shopee.workspace.mapping.shop-unselected": "sin seleccionar",
  "shopee.workspace.mapping.loading": "Cargando vinculaciones desde Shopee...",
  "shopee.workspace.mapping.empty": "Shopee no devolvió vinculaciones que coincidan con la tienda y el filtro actual.",
  "shopee.workspace.mapping.detail-title": "Detalles de la vinculación",
  "shopee.workspace.mapping.tab-info": "Información",
  "shopee.workspace.mapping.tab-history": "Historial",
  "shopee.workspace.mapping.status.disabled": "Sincronización desactivada",
  "shopee.workspace.mapping.status.error": "Error de sincronización",
  "shopee.workspace.mapping.status.healthy": "Saludable",
  "shopee.workspace.mapping.status.mapping-required": "Sin vincular",
  "shopee.workspace.mapping.status.out-of-stock": "Agotado",
  "shopee.workspace.mapping.section-vmass": "Información de VMASS",
  "shopee.workspace.mapping.section-shopee": "Datos de Shopee",
  "shopee.workspace.mapping.available-stock": "Stock disponible",
  "shopee.workspace.mapping.shopee-name-colon": "Nombre en Shopee:",
  "shopee.workspace.mapping.not-linked": "Sin vincular al canal Shopee",
  "shopee.workspace.mapping.sync-enabled-colon": "Sincronización permitida:",
  "shopee.workspace.mapping.auto-map-this": "Auto-vincular este SKU",
  "shopee.workspace.mapping.change": "Cambiar vinculación",
  "shopee.workspace.mapping.remove": "Quitar vinculación",
  "shopee.workspace.mapping.history-created": "Vinculación creada:",
  "shopee.workspace.mapping.history-updated": "Vinculación actualizada:",
  "shopee.workspace.mapping.history-last-sync": "Última sincronización con Shopee:",
  "shopee.workspace.mapping.sync-stock-to-shopee": "Sincronizar stock con Shopee",
  "shopee.workspace.mapping.modal-title": "Elegir un producto VMASS para vincular",
  "shopee.workspace.mapping.candidate-search-placeholder": "Buscar por nombre, SKU o código de barras de VMASS",
  "shopee.workspace.mapping.candidates-loading": "Cargando productos VMASS...",
  "shopee.workspace.mapping.choose-product": "Elegir producto VMASS",
  "shopee.workspace.mapping.nameless-product": "Producto sin nombre",
  "shopee.workspace.mapping.choose-variant": "Elegir variante de VMASS",
  "shopee.workspace.mapping.no-variants-note": "Este producto VMASS no tiene variantes; la vinculación usará el stock del producto base.",
  "shopee.workspace.mapping.no-candidates": "Ningún producto VMASS coincide con la búsqueda.",
  "shopee.workspace.mapping.create-product": "Crear producto nuevo",
  "shopee.workspace.mapping.save": "Guardar vinculación",
  "shopee.workspace.mapping.auto-map-selected": "Auto-vincular seleccionados ({count})",
  "template.profile.title": "Datos de ejemplo guiados",
  "template.profile.description": "Los productos e ingredientes de ejemplo le ayudan a explorar el sistema. Puede ocultarlos o mostrarlos de nuevo según sea necesario.",
  "template.profile.dismiss": "Ocultar datos de ejemplo",
  "template.profile.show": "Mostrar datos de ejemplo",
  "template.profile.confirm": "Los datos de ejemplo y sus pedidos se ocultarán, y se restaurará el inventario utilizado. ¿Continuar?",
  "template.profile.show-confirm": "¿Está seguro de que desea mostrar los datos de ejemplo de nuevo?",
  "template.profile.success": "Datos de ejemplo ocultados con éxito",
  "template.profile.show-success": "¡Datos de ejemplo mostrados con éxito!",
  "menu.stock-out": "Salida de almacén",
  "stock-out.subtitle": "Gestiona salidas internas, devoluciones a proveedores y bajas con aprobación.",
  "stock-out.create": "Crear salida",
  "einvoice.filter.issuance-status": "Estado de emisión",
  "einvoice.filter.invoice-status": "Estado de factura",
  "einvoice.filter.all": "Todos",
  "einvoice.issuance-status.pending": "Pendiente",
  "einvoice.issuance-status.success": "Éxito",
  "einvoice.issuance-status.failed": "Error",
  "einvoice.invoice-status.draft": "Borrador",
  "einvoice.invoice-status.issued": "Emitida",
  "template.badge": "Datos de ejemplo",
  "template.convert": "Convertir en datos reales",
  "product.btn-update": "Actualizar producto",
  "home.warning.dismiss-template": "Está viendo datos de ejemplo. Oculte o elimine los datos de ejemplo antes de su uso real",
  "home.warning.dismiss-btn": "Ocultar datos de ejemplo",
  "home.warning.dismiss-confirm": "¿Está seguro de que desea ocultar todos los datos de ejemplo?",
  "home.warning.dismiss-success": "¡Datos de ejemplo ocultados con éxito!",
  "home.warning.here": "aquí",
  "shopee.workspace.shipping.customer-fallback": "Cliente {number}",
  "shopee.workspace.shipping.product-fallback": "Producto de Shopee",
  "shopee.workspace.shipping.service-standard": "Entrega estándar",
  "shopee.workspace.shipping.status.ready-pickup": "Esperando recogida",
  "shopee.workspace.shipping.status.processing": "En proceso",
  "shopee.workspace.shipping.checklist.inspect": "Inspeccionar productos",
  "shopee.workspace.shipping.checklist.protect": "Embalaje antichoque",
  "shopee.workspace.shipping.col.order-sub": "Código | Canal",
  "shopee.workspace.shipping.col.phone-sub": "Teléfono",
  "shopee.workspace.shipping.col.amount": "Valor de mercancía",
  "shopee.workspace.shipping.col.progress-sub": "Progreso",
  "shopee.workspace.shipping.print-slip-title": "Imprimir comprobante",
  "shopee.workspace.shipping.alert.print-slip": "Imprimir comprobante de entrega del pedido {sn}",
  "shopee.workspace.shipping.alert.update-status": "Actualizar estado del pedido {sn}",
  "shopee.workspace.shipping.action.update-status": "Actualizar estado",
  "shopee.workspace.shipping.alert.cancel-order": "Cancelar pedido {sn}",
  "shopee.workspace.shipping.action.cancel-order": "Cancelar pedido",
  "shopee.workspace.shipping.subtitle": "Gestione el procesamiento, embalaje y entrega de pedidos en todos los canales.",
  "shopee.workspace.shipping.create-shipping-order": "Crear orden de envío",
  "shopee.workspace.shipping.alert.print-labels-bulk": "Impresión masiva de etiquetas",
  "shopee.workspace.shipping.action.print-bulk": "Impresión masiva",
  "shopee.workspace.shipping.alert.export-excel": "Exportar lista a Excel",
  "shopee.workspace.shipping.alert.syncing-orders": "Sincronizando nuevos pedidos de los canales...",
  "shopee.workspace.shipping.kpi.overdue": "{count} pedidos vencidos",
  "shopee.workspace.shipping.kpi.packing": "Empaquetando",
  "shopee.workspace.shipping.kpi.packing-sub": "1 en curso",
  "shopee.workspace.shipping.kpi.pickup-today": "Recogida hoy",
  "shopee.workspace.shipping.kpi.handover": "Entregado al transportista",
  "shopee.workspace.shipping.kpi.shipping": "En reparto",
  "shopee.workspace.shipping.kpi.shipping-sub": "En tránsito",
  "shopee.workspace.shipping.step.delivered": "Completado",
  "shopee.workspace.shipping.step.picking": "Preparación",
  "shopee.workspace.shipping.action.print-label": "Imprimir etiqueta de envío",
  "shopee.workspace.shipping.search-placeholder": "Buscar código, cliente, teléfono...",
  "shopee.workspace.shipping.filter.all-carriers": "Todos los transportistas",
  "shopee.workspace.common.yesterday": "Ayer",
  "shopee.workspace.common.this-month": "Este mes",
  "shopee.workspace.shipping.pagination-summary": "Mostrando 1 - {count} de {total} pedidos",
  "shopee.workspace.shipping.perf.performance-today": "Rendimiento de hoy",
  "shopee.workspace.shipping.perf.updated-at": "Actualizado 10:30",
  "shopee.workspace.shipping.perf.processed": "Procesados",
  "shopee.workspace.shipping.perf.orders-value": "{count} pedidos",
  "shopee.workspace.shipping.perf.on-time": "A tiempo",
  "shopee.workspace.shipping.perf.overdue": "Vencidos",
  "shopee.workspace.shipping.perf.success-rate": "Tasa de entrega exitosa",
  "shopee.workspace.shipping.perf.returns": "Pedidos devueltos",
  "shopee.workspace.shipping.perf.top-carriers": "Mejores transportistas",
  "shopee.workspace.shipping.alert.close-detail": "Cerrar panel de detalles",
  "shopee.workspace.shipping.section-customer": "Información del cliente",
  "shopee.workspace.shipping.title.call": "Llamar",
  "shopee.workspace.shipping.alert.call": "Llamar al {phone}",
  "shopee.workspace.shipping.title.address": "Ver dirección",
  "shopee.workspace.shipping.section-products": "Productos ({count})",
  "shopee.workspace.shipping.section-shipping-info": "Información de envío",
  "shopee.workspace.shipping.col.carrier": "Transportista",
  "shopee.workspace.shipping.title.copy-code": "Copiar código",
  "shopee.workspace.shipping.alert.copied": "Copiado: {code}",
  "shopee.workspace.shipping.col.service": "Servicio",
  "shopee.workspace.shipping.col.shipping-fee": "Tarifa de envío",
  "shopee.workspace.shipping.col.cod": "Contra reembolso (COD)",
  "shopee.workspace.shipping.col.total-collect": "Total a recaudar",
  "shopee.workspace.shipping.checklist-title": "Lista de embalaje",
  "shopee.workspace.shipping.alert.print-label": "Imprimir etiqueta para {sn}",
  "shopee.workspace.shipping.action.print-slip": "Imprimir albarán",
  "shopee.workspace.shipping.alert.print-slip-order": "Imprimir albarán para {sn}",
  "shopee.workspace.shipping.action.packed-done": "Empaquetado completo",
  "shopee.workspace.shipping.notice.packed-handover": "Embalaje completado; pasado al estado Esperando entrega",
  "shopee.workspace.shipping.alert.packed-done": "Embalaje completado del pedido {sn}",
  "shopee.workspace.shipping.action.complete-handover": "Completar y pasar a espera de entrega",
  "shopee.workspace.shipping.action.report-shortage": "Informar de falta de stock",
  "shopee.workspace.shipping.action.delay-packing": "Posponer embalaje",
  "shopee.workspace.shipping.scan.title": "Estación de embalaje - Escanear código",
  "shopee.workspace.shipping.scan.desc": "Escanee el código de barras o ingrese el código de seguimiento / pedido de Shopee para verificar e imprimir etiquetas al instante:",
  "shopee.workspace.shipping.scan.label": "Código de pedido / Seguimiento",
  "shopee.workspace.shipping.scan.placeholder": "Ej.: SP24072201 o GHN1234567890...",
  "shopee.workspace.shipping.alert.not-found": "No se encontró ningún pedido con el código: {code}",
  "shopee.workspace.shipping.scan.now": "Escanear ahora",
  "shopee.workspace.finance.channel-pos": "POS - Tienda",
  "shopee.workspace.finance.status.paid": "Pagado",
  "shopee.workspace.finance.status.pending-payment": "Pendiente de pago",
  "shopee.workspace.finance.status.discrepancy": "Discrepancia",
  "shopee.workspace.finance.status.dispute": "Disputa",
  "shopee.workspace.finance.bank-encrypted": "Cuenta cifrada",
  "shopee.workspace.finance.payout.transferred": "Transferido",
  "shopee.workspace.finance.payout.processing": "En proceso",
  "shopee.workspace.finance.sync-queued": "Sincronización de conciliación programada",
  "shopee.workspace.finance.subtitle": "Rastree, concilie y gestione pagos de todos los canales de venta",
  "shopee.workspace.finance.forecast": "Previsión de cobros",
  "shopee.workspace.finance.export-report": "Exportar informe",
  "shopee.workspace.finance.action.sync": "Sincronizar conciliación",
  "shopee.workspace.finance.kpi.revenue": "Ingresos",
  "shopee.workspace.finance.kpi.vs-prev-period": "vs periodo anterior",
  "shopee.workspace.finance.kpi.pending-reconciliation": "Conciliación pendiente",
  "shopee.workspace.finance.kpi.holding": "Retenido",
  "shopee.workspace.finance.kpi.refund": "Reembolsos",
  "shopee.workspace.finance.kpi.fees": "Comisiones y deducciones",
  "shopee.workspace.finance.cashflow-title": "Flujo de caja",
  "shopee.workspace.finance.net-received": "Neto recibido",
  "shopee.workspace.finance.forecast.tomorrow": "Mañana",
  "shopee.workspace.finance.forecast.next-3-days": "Próximos 3 días",
  "shopee.workspace.finance.forecast.next-week": "Próxima semana",
  "shopee.workspace.finance.forecast.view-detail": "Ver detalles de la previsión →",
  "shopee.workspace.finance.filter.all-banks": "Todas las cuentas bancarias",
  "shopee.workspace.finance.col.sn": "Código de liquidación",
  "shopee.workspace.finance.col.period": "Periodo de liquidación",
  "shopee.workspace.finance.col.order-count": "Pedidos",
  "shopee.workspace.finance.col.payout-date": "Fecha de pago",
  "shopee.workspace.finance.action.export-excel-file": "Exportar archivo Excel",
  "shopee.workspace.finance.detail-title": "Detalles de la liquidación",
  "shopee.workspace.finance.meta.period": "Periodo:",
  "shopee.workspace.finance.meta.payout-date": "Fecha de pago:",
  "shopee.workspace.finance.meta.bank-account": "Cuenta receptora:",
  "shopee.workspace.finance.meta.transaction-code": "Código de transacción:",
  "shopee.workspace.finance.meta.status": "Estado:",
  "shopee.workspace.finance.tab-orders": "Detalles de pedidos ({count})",
  "shopee.workspace.finance.bd.gross-revenue": "Ingresos totales",
  "shopee.workspace.finance.bd.platform-deduction": "Deducciones de la plataforma ^",
  "shopee.workspace.finance.bd.voucher": "Cupones de la plataforma",
  "shopee.workspace.finance.bd.shipping-buyer": "Tarifa de envío (pagada por el comprador)",
  "shopee.workspace.finance.bd.seller-discount": "Descuentos de la plataforma",
  "shopee.workspace.finance.bd.payment-fee": "Comisión de pago",
  "shopee.workspace.finance.bd.service-fee": "Tarifa de servicio",
  "shopee.workspace.finance.bd.tax": "Impuestos",
  "shopee.workspace.finance.bd.refunds": "Reembolsos / Devoluciones ^",
  "shopee.workspace.finance.bd.refund-fee": "Tarifa de reembolso",
  "shopee.workspace.finance.bd.other-deductions": "Otras deducciones",
  "shopee.workspace.finance.action.view-documents": "Ver documentos de conciliación",
  "shopee.workspace.finance.action.download-statement": "Descargar extracto",
  "shopee.workspace.finance.discrepancy.alert": "Discrepancia a revisar:",
  "shopee.workspace.finance.discrepancy.desc": "{count} pedidos tienen diferencias entre VMASS y el canal.",
  "shopee.workspace.finance.widget.success-rate": "Tasa de éxito de conciliación",
  "shopee.workspace.finance.legend.success": "Éxito:",
  "shopee.workspace.finance.legend.failed": "Fallidos:",
  "shopee.workspace.finance.widget.top-revenue-channels": "Canales con mayores ingresos",
  "shopee.workspace.finance.channel-others": "Otros",
  "shopee.workspace.finance.widget.popular-refund-reasons": "Motivos frecuentes de reembolso",
  "shopee.workspace.finance.reason.wrong-color": "Color/tono incorrecto:",
  "shopee.workspace.finance.reason.wrong-size": "Talla incorrecta:",
  "shopee.workspace.finance.reason.defect": "Defecto del producto:",
  "shopee.workspace.finance.reason.not-liked": "No gustó:",
  "shopee.workspace.finance.insight.unpaid-orders": "Tiene {count} pedidos de Shopee entregados hace más de 10 días sin pago aún.",
  "shopee.workspace.finance.insight.transfer-tomorrow": "Shopee transferirá alrededor de 42 millones mañana ({date}).",
  "shopee.workspace.finance.insight.fee-increase": "Las tarifas de envío de TikTok Shop subieron {percent} frente al mes pasado.",
  "shopee.workspace.finance.insight.view-more": "Ver más análisis →",
  "shopee.workspace.issues.channel-other": "Otro canal",
  "shopee.workspace.common.order-hash": "Pedido",
  "shopee.workspace.common.product-hash": "Producto",
  "shopee.workspace.tab.shipping-short": "Envío",
  "shopee.workspace.issues.subtitle": "Rastree, gestione y corrija problemas de conexión, sincronización y sistema",
  "shopee.workspace.issues.severity.critical": "Crítico",
  "shopee.workspace.issues.severity.high": "Alto",
  "shopee.workspace.issues.severity.medium": "Medio",
  "shopee.workspace.issues.severity.low": "Bajo",
  "shopee.workspace.issues.status.unresolved": "Sin resolver",
  "shopee.workspace.issues.status.in-progress": "En progreso",
  "shopee.workspace.issues.status.waiting": "En espera",
  "shopee.workspace.issues.status.resolved": "Resuelto",
  "shopee.workspace.issues.status.ignored": "Ignorado",
  "shopee.workspace.issues.type.order-sync": "Sincronización de pedidos",
  "shopee.workspace.issues.type.product-sync": "Sincronización de productos",
  "shopee.workspace.issues.type.system-task": "Tarea del sistema",
  "shopee.workspace.issues.type.system": "Sistema",
  "shopee.workspace.issues.type.stock-sync": "Sincronización de stock",
  "shopee.workspace.issues.type.api-connection": "Conexión API",
  "shopee.workspace.issues.type.payment": "Pago",
  "shopee.workspace.issues.filter.all-types": "Todos los tipos",
  "shopee.workspace.issues.filter.all-severities": "Todas las severidades",
  "shopee.workspace.issues.error.order-sync": "Error de sincronización de pedidos",
  "shopee.workspace.issues.error.check-order-status": "Verifique el estado del pedido",
  "shopee.workspace.issues.error.sku-mapping": "Error de vinculación de SKU",
  "shopee.workspace.issues.error.sku-unmapped": "SKU sin vincular en VMASS o error de sincronización de stock",
  "shopee.workspace.issues.error.job-ended-status": "La tarea terminó con estado {status}",
  "shopee.workspace.issues.error.retried-times": "Reintentado {count} veces",
  "shopee.workspace.issues.action.process-label": "Gestionar incidencia {id}",
  "shopee.workspace.issues.action.process-now": "Gestionar ahora",
  "shopee.workspace.issues.action.ignore-label": "Ignorar incidencia {id}",
  "shopee.workspace.issues.action.ignore": "Ignorar",
  "shopee.workspace.issues.action.mark-resolved": "Marcar como resuelto",
  "shopee.workspace.issues.empty": "No se encontraron incidencias coincidentes",
  "shopee.workspace.issues.pagination-of": "de {total} incidencias",
  "shopee.workspace.issues.total-errors": "Total de incidencias",
  "shopee.workspace.issues.chart.by-channel": "Incidencias por canal",
  "shopee.workspace.issues.chart.by-type": "Incidencias por tipo",
  "shopee.workspace.issues.chart.by-severity": "Incidencias por severidad",
  "shopee.workspace.issues.chart.timeline": "Cronología de incidencias",
  "shopee.workspace.issues.chart.top-errors": "Principales incidencias",
  "shopee.workspace.issues.times-count": "{count} veces",
  "shopee.workspace.issues.top.order-list": "No se pudo obtener la lista de pedidos",
  "shopee.workspace.issues.top.invalid-data": "Datos no válidos",
  "shopee.workspace.issues.top.negative-stock": "Stock negativo",
  "shopee.workspace.issues.top.payment-not-found": "Transacción de pago no encontrada",
  "shopee.workspace.issues.activity.processed": "gestionó la incidencia de TikTok Shop - Sincronización de productos",
  "shopee.workspace.issues.activity.resolved": "resolvió la incidencia",
  "shopee.workspace.issues.drawer.title": "Detalles de la incidencia",
  "shopee.workspace.issues.drawer.info-title": "Información de la incidencia",
  "shopee.workspace.issues.drawer.error-code": "Código de error",
  "shopee.workspace.issues.drawer.request": "Solicitud",
  "shopee.workspace.issues.drawer.request-detail": "Detalle de la solicitud",
  "shopee.workspace.issues.drawer.response-detail": "Detalle de la respuesta",
  "shopee.workspace.issues.drawer.impact-title": "Impacto",
  "shopee.workspace.issues.drawer.impact-orders": "Pedidos afectados",
  "shopee.workspace.issues.drawer.impact-products": "Productos afectados",
  "shopee.workspace.issues.drawer.impact-revenue": "Ingresos afectados",
  "shopee.workspace.issues.drawer.suggestions-title": "Soluciones sugeridas",
  "shopee.workspace.issues.suggest.check-api": "Verifique la conexión API de Shopee",
  "shopee.workspace.issues.suggest.check-status": "Verifique el estado del sistema de Shopee",
  "shopee.workspace.issues.suggest.retry-sync": "Reintente la sincronización en unos minutos",
  "shopee.workspace.issues.suggest.contact-support": "Contacte con soporte si el problema persiste",
  "shopee.workspace.issues.drawer.note-title": "Nota interna",
  "shopee.workspace.issues.confirm.title": "Confirmar gestión de la incidencia",
  "shopee.workspace.issues.confirm.desc": "¿Seguro que desea realizar esta acción?",
  "shopee.workspace.issues.confirm.items": "{label} ({count} elementos)",
  "shopee.workspace.issues.confirm.ok": "Confirmar",
  "shopee.workspace.issues.confirm.queued": "Tarea de remediación en cola",
  "shopee.workspace.issues.kpi.all": "Todas las incidencias",
  "shopee.workspace.issues.kpi.all-sub": "Total de problemas detectados",
  "shopee.workspace.issues.kpi.unresolved-sub": "Requiere revisión inmediata",
  "shopee.workspace.issues.kpi.in-progress": "Incidencias en progreso",
  "shopee.workspace.issues.kpi.in-progress-sub": "Siendo procesadas actualmente",
  "shopee.workspace.issues.kpi.resolved": "Incidencias resueltas",
  "shopee.workspace.issues.kpi.resolved-sub": "Corregidas con éxito",
  "shopee.workspace.issues.kpi.critical": "Incidencias críticas",
  "shopee.workspace.issues.kpi.critical-sub": "Severidad alta y crítica",
  "shopee.workspace.issues.action.configure-alerts": "Configurar alertas",
  "shopee.workspace.issues.action.system-logs": "Registros del sistema",
  "shopee.workspace.issues.col.channel-source": "Canal / Fuente",
  "shopee.workspace.issues.col.type": "Tipo de incidencia",
  "shopee.workspace.issues.col.severity": "Severidad",
  "shopee.workspace.issues.col.object": "Objeto",
  "shopee.workspace.issues.col.message": "Mensaje de error",
  "shopee.workspace.listing.description-template": "{name} - Producto de alta calidad",
  "shopee.workspace.listing.err.no-shop": "Ninguna tienda de Shopee seleccionada",
  "shopee.workspace.listing.err.no-product": "Ningún producto VMASS seleccionado",
  "shopee.workspace.listing.err.name-length": "El nombre debe tener entre 5 y 120 caracteres",
  "shopee.workspace.listing.err.desc-length": "La descripción debe tener al menos 25 caracteres",
  "shopee.workspace.listing.err.price": "El precio debe ser mayor que 0",
  "shopee.workspace.listing.err.variant-price": "El precio de cada variante debe ser mayor que 0",
  "shopee.workspace.listing.err.weight": "El peso debe estar entre 0,01 y 50 kg",
  "shopee.workspace.listing.err.no-category": "Ninguna categoría de Shopee seleccionada",
  "shopee.workspace.listing.err.brand-load-failed": "No se pudieron cargar las marcas de Shopee",
  "shopee.workspace.listing.err.no-brand": "Ninguna marca de Shopee seleccionada",
  "shopee.workspace.listing.err.no-logistics": "Ningún canal de envío seleccionado",
  "shopee.workspace.listing.err.missing-attribute": "Falta el atributo: {attribute}",
  "shopee.workspace.listing.err.dimensions": "Las tres dimensiones deben completarse y ser mayores que 0",
  "shopee.workspace.listing.update-queued": "Solicitud de actualización del listing en cola",
  "shopee.workspace.listing.publish-queued": "Producto en cola para publicar en Shopee",
  "shopee.workspace.listing.label.shop": "Tienda de Shopee *",
  "shopee.workspace.listing.no-shops": "Ninguna tienda de Shopee disponible",
  "shopee.workspace.listing.primary-mark": "Principal",
  "shopee.workspace.listing.shop-hint": "Los datos de categoría, marca y envío se cargarán según la tienda seleccionada.",
  "shopee.workspace.listing.label.brand": "Marca de Shopee",
};
